"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8073],{

/***/ 84333:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Me": () => (/* binding */ TravelNote),
/* harmony export */   "Nj": () => (/* binding */ PopularCountry),
/* harmony export */   "P5": () => (/* binding */ BgText),
/* harmony export */   "QQ": () => (/* binding */ PopularCountryItem),
/* harmony export */   "Q_": () => (/* binding */ CountryImg),
/* harmony export */   "S_": () => (/* binding */ DiscountingNote),
/* harmony export */   "TR": () => (/* binding */ TripUpcoming),
/* harmony export */   "Vr": () => (/* binding */ UpcomingTripStyle),
/* harmony export */   "cM": () => (/* binding */ UpcomingTripTag),
/* harmony export */   "fK": () => (/* binding */ TravellingToStyleWrap),
/* harmony export */   "in": () => (/* binding */ OtherCountyBtn),
/* harmony export */   "s0": () => (/* binding */ TravellingToStyle),
/* harmony export */   "xZ": () => (/* binding */ CountryNameTxt)
/* harmony export */ });
/* unused harmony exports TravelDetailsStyle, ButtonWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54927);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);




const TravelDetailsStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelDetailsStyle",
  componentId: "sc-1eenbn7-0"
})(["background:#ffffff;padding:30px;"]);
const TravellingToStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyle",
  componentId: "sc-1eenbn7-1"
})(["background:#ffffff;padding:30px;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;position:relative;", "{padding:5px;margin:-5px;}@media ", "{padding:16px;margin-bottom:36px;}"], _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .TagsStyle */ .EN, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const PopularCountry = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountry",
  componentId: "sc-1eenbn7-2"
})(["display:flex;flex-wrap:wrap;gap:8px;label{left:0 !important;position:absolute;bottom:8px;z-index:1;}@media ", "{margin-bottom:16px;display:grid;grid-template-columns:repeat(3,1fr);grid-gap:14px;width:calc(100vw - 64px);min-height:178px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const PopularCountryItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountryItem",
  componentId: "sc-1eenbn7-3"
})(["background:linear-gradient(228.82deg,#43c6ac 2.05%,#191654 93.35%);border:1px solid #fff;border-radius:6px;z-index:1;padding:8px;overflow:hidden;width:80px;height:82px;position:relative;flex-shrink:0;cursor:pointer;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);", " > div{cursor:pointer;}picture{height:82px;}@media ", "{width:unset;height:82px;picture{height:82px;}}"], p => p.listSelected && `
        border: 1px solid #008cff;
        `, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const OtherCountyBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__OtherCountyBtn",
  componentId: "sc-1eenbn7-4"
})(["display:flex;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);flex-direction:column;gap:8px;width:80px;height:82px;background:#fff;border-radius:6px;padding:8px;cursor:pointer;@media ", "{width:unset;height:82px;gap:6px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const CountryImg = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__CountryImg",
  componentId: "sc-1eenbn7-5"
})(["position:absolute;top:0px;left:0px;bottom:0;z-index:-1;max-width:100%;max-height:100%;width:100%;picture{width:100%;}picture img{width:80px;height:80px;}:after{content:\"\";position:absolute;border-radius:0px 0px 6px 6px;background:linear-gradient( 180deg,rgba(106,106,106,0) 0%,rgba(0,0,0,0.7) 100% );width:100%;height:32px;bottom:1px;left:0;}@media ", "{picture img{width:100%;height:82px;}}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const TravelNote = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelNote",
  componentId: "sc-1eenbn7-6"
})(["background:linear-gradient( 85.23deg,rgba(67,225,168,0.5) 0%,rgba(33,147,147,0.5) 100% );border-radius:8px 8px 0px 0px;padding:8px 78px;margin:0 auto;color:#fff;font-size:16px;width:550px;text-align:center;em{font-weight:600;color:#8beecd;font-style:normal;}@media ", "{width:92%;padding:12px;font-size:12px;text-align:center;padding-bottom:24px;margin-bottom:-12px;}@media ", "{", "}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.desktop, p => p.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.PARTNER.MMT ? `
        background: linear-gradient(45deg, #43E1A8 0%, #219393 100%);
    ` : p.pageTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.PARTNER.GI ? `background: #18A160;` : ``);
const DiscountingNote = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__DiscountingNote",
  componentId: "sc-1eenbn7-7"
})(["border-radius:8px 8px 0px 0px;padding:8px 0px 8px 16px;margin:0 auto;color:", ";width:550px;display:flex;align-items:center;@media ", "{width:92%;padding:12px;padding-bottom:24px;margin-bottom:-12px;background:#e4fbf4;}@media ", "{background:#e4fbf4;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText5 */ .rS.greyText5, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.desktop);
const TravellingToStyleWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyleWrap",
  componentId: "sc-1eenbn7-8"
})([""]);
const UpcomingTripStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripStyle",
  componentId: "sc-1eenbn7-9"
})(["display:flex;align-items:center;justify-content:space-between;background:#ffffff;border-radius:6px;padding:24px 12px 12px;margin-bottom:16px;position:relative;cursor:pointer;", " ", "{width:24px;height:24px;}&::before{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border:1px solid transparent;background:", ";-webkit-mask:linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;border-radius:6px;}"], p => p.selected && `
    background: #EAF5FF;
    border: 1px solid #008CFF;
  `, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .AnchorTagStyle */ .C2, _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.purpleGradient */ .rS.purpleGradient);
const UpcomingTripTag = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripTag",
  componentId: "sc-1eenbn7-10"
})(["background:", ";padding:2px 6px;border-radius:6px 0px 6px 0px;width:fit-content;position:absolute;top:0;left:0;display:flex;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.purpleGradient */ .rS.purpleGradient);
const BgText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravelDetailsstyle__BgText",
  componentId: "sc-1eenbn7-11"
})(["background:radial-gradient( 59.37% 231.91% at 3.11% 23.44%,rgba(255,255,255,0.24) 0%,rgba(255,255,255,0.144) 100% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-style:normal;font-weight:700;font-size:56px;line-height:64px;position:absolute;top:-59px;right:6px;"]);
const TripUpcoming = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TripUpcoming",
  componentId: "sc-1eenbn7-12"
})(["background:linear-gradient( 91.22deg,#9c005e 1.88%,rgba(22,20,60,0.2) 100% );padding:2px 8px;color:#fff;position:absolute;bottom:24px;left:-10px;white-space:nowrap;width:100%;font-weight:400;font-size:9px;line-height:11px;text-transform:uppercase;text-wrap:wrap;"]);
const CountryNameTxt = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravelDetailsstyle__CountryNameTxt",
  componentId: "sc-1eenbn7-13"
})(["display:-webkit-box;color:#ffffff;font-size:12px;-webkit-line-clamp:2;font-weight:700;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;white-space:normal;width:75%;text-shadow:0px 0px 8px rgba(0,0,0,0.8);"]);
const ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravelDetailsstyle__ButtonWrapper",
  componentId: "sc-1eenbn7-14"
})(["position:fixed;bottom:0;background:#fff;padding:16px;left:0;right:0;width:100%;z-index:1;"]);

/***/ }),

/***/ 62915:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ TravelDetails_TravellingToShimmer)
});

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.style.ts
var TravellingToWidget_style = __webpack_require__(98892);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidgetShimmer.tsx





const TravellingToWidgetShimmer = ({}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellingToWidgetStyle */.bF, {
    "data-test-id": "TravellingToWidgetShimmer-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravelDateWigetShimmerStyle */.fF, {
      "data-test-id": "TravellingToWidgetShimmer-TravelDateWigetShimmerStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCountWigetShimmerStyle */.Mf, {
      "data-test-id": "TravellingToWidgetShimmer-TravellerCountWigetShimmerStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellingToWidgetShimmer = (TravellingToWidgetShimmer);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravelDetails.style.ts
var TravelDetails_style = __webpack_require__(84333);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx







const TravellingToShimmer = () => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyleWrap */.fK, {
    "data-test-id": "TravellingToShimmer-TravellingToStyleWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TravelNote */.Me, {
      "data-test-id": "TravellingToShimmer-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion3 */.AO, {
        height: "22px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyle */.s0, {
      "data-test-id": "TravellingToShimmer-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        margin: "0 0 16px",
        width: "100%",
        height: "28px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
        margin: "0 0 8px",
        width: "80%",
        height: "16px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        margin: device == "sm" ? "0 0 20px" : "",
        flexWrap: "wrap",
        gap: "8px",
        "data-test-id": "TravellingToShimmer-FlexComp",
        children: Array.from({
          length: 5
        }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion2 */.KQ, {
          width: "89px",
          height: "79px",
          "data-test-id": `TravellingToShimmer-ShimmerVersion2-${index}`
        }, index))
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionDividers */.LV, {
        margin: "30px -30px 30px",
        xs: true,
        "data-test-id": "TravellingToShimmer-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellingToWidgetShimmer, {
        "data-test-id": "TravellingToShimmer-TravellingToWidgetShimmer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShimmerVersion3 */.AO, {
        width: "100%",
        height: "44px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })]
    })]
  });
};

/* harmony default export */ const TravelDetails_TravellingToShimmer = (TravellingToShimmer);

/***/ }),

/***/ 98892:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": () => (/* binding */ TravellerCountWigetStyle),
/* harmony export */   "Jp": () => (/* binding */ TravelDateWigetStyle),
/* harmony export */   "Mf": () => (/* binding */ TravellerCountWigetShimmerStyle),
/* harmony export */   "N": () => (/* binding */ ChevStateWrap),
/* harmony export */   "ZN": () => (/* binding */ CounterBtn),
/* harmony export */   "ZP": () => (/* binding */ DateSeparator),
/* harmony export */   "bF": () => (/* binding */ TravellingToWidgetStyle),
/* harmony export */   "fF": () => (/* binding */ TravelDateWigetShimmerStyle),
/* harmony export */   "vg": () => (/* binding */ CounterWrap)
/* harmony export */ });
/* unused harmony exports TravelPurposeWigetStyle, WidgetList, ListItem, EmptySpace, ChevWrap, BtnWrap */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54927);



const TravellingToWidgetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellingToWidgetStyle",
  componentId: "sc-1vav6o1-0"
})(["display:flex;margin-bottom:24px;position:relative;@media ", "{flex-direction:column;", "{height:300px;}}", "{position:absolute;top:-20px;left:-20px;background:#005756;bottom:auto;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .CommonModalDwebStyle */ .E5, _tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .ToastStyle */ .jf);
const TravelPurposeWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelPurposeWigetStyle",
  componentId: "sc-1vav6o1-1"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;flex:2;cursor:pointer;position:relative;border-left:none;"]);
const TravellerCountWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetStyle",
  componentId: "sc-1vav6o1-2"
})(["background:#ffffff;border:1px solid #e7e7e7;padding:8px 16px;flex:1.1;position:relative;display:flex;justify-content:space-between;gap:8px;align-items:center;@media ", "{border-radius:0 0 8px 8px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const TravellerCountWigetShimmerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(TravellerCountWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetShimmerStyle",
  componentId: "sc-1vav6o1-3"
})(["display:flex;gap:20px;align-items:end;"]);
const TravelDateWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetStyle",
  componentId: "sc-1vav6o1-4"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;border-right:none;flex:1;cursor:pointer;position:relative;@media ", "{border-right:1px solid #e7e7e7;border-bottom:none;border-radius:8px 8px 0 0;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const TravelDateWigetShimmerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(TravelDateWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetShimmerStyle",
  componentId: "sc-1vav6o1-5"
})(["display:flex;gap:20px;align-items:end;"]);
/* istanbul ignore next */

const WidgetList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__WidgetList",
  componentId: "sc-1vav6o1-6"
})(["background:#ffffff;box-shadow:0px 1px 6px rgba(0,0,0,0.2);border-radius:6px;width:", ";height:213px;overflow-y:scroll;position:absolute;top:30px;right:0;z-index:1;", ""], p => p.width ? p.width : "111px", p => p.travelCount && `
left:250px;
`);
const ListItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ListItem",
  componentId: "sc-1vav6o1-7"
})(["padding:8px 16px;border-bottom:1px solid #ebebeb;cursor:pointer;display:flex;align-items:center;", " @media ", "{padding:12px 24px;display:flex;align-items:center;justify-content:center;&:last-child{margin-bottom:60px;}}"], p => p.selected && `
    ${_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .SpanTagStyle */ .zs}{
        color:#008CFF;
        font-weight:700;
    }
    `, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const EmptySpace = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__EmptySpace",
  componentId: "sc-1vav6o1-8"
})(["width:100%;height:60px;padding:18px;"]);
const ChevWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevWrap",
  componentId: "sc-1vav6o1-9"
})(["margin-left:auto;"]);
const DateSeparator = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_tm_ui_widgets_components__WEBPACK_IMPORTED_MODULE_2__/* .SpanTagStyle */ .zs).withConfig({
  displayName: "TravellingToWidgetstyle__DateSeparator",
  componentId: "sc-1vav6o1-10"
})(["flex-shrink:0;"]);
const ChevStateWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevStateWrap",
  componentId: "sc-1vav6o1-11"
})(["transition:0.5s ease-in;", ""], p => p.open && `
transform:rotate(180deg);
`);
const BtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__BtnWrap",
  componentId: "sc-1vav6o1-12"
})(["background:var(--base-white,#fff);box-shadow:0px -1px 8px 0px rgba(0,0,0,0.25);padding:16px;position:fixed;bottom:0;left:0px;right:0px;"]);
const CounterWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__CounterWrap",
  componentId: "sc-1vav6o1-13"
})(["border-radius:4px;background:#fff;box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);padding:0px 8px;display:flex;gap:14px;align-items:center;width:fit-content;height:40px;button{background:transparent;cursor:pointer;display:flex;padding:0;}span{word-break:unset;}"]);
const CounterBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "TravellingToWidgetstyle__CounterBtn",
  componentId: "sc-1vav6o1-14"
})(["", ""], p => p.isDiabled && `
pointer-events:none;
opacity:0.5;
`);

/***/ }),

/***/ 58990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Breadcrumb": () => (/* reexport */ Breadcrumb_Breadcrumb),
  "ClaimYourInsurance": () => (/* reexport */ ClaimYourInsurance_ClaimYourInsurance),
  "DomesticTrip": () => (/* reexport */ DomesticTravelDetail_DomesticTrip),
  "ExclusiveOffers": () => (/* reexport */ ExculsiveOffers_ExclusiveOffers),
  "InsuranceStats": () => (/* reexport */ InsuranceStats_InsuranceStats),
  "InterlinkingBlock": () => (/* reexport */ InterlinkingBlock_InterlinkingBlock),
  "LandingFaq": () => (/* reexport */ LandingFaq_LandingFaq),
  "LandingFooter": () => (/* reexport */ LandingFooter_LandingFooter),
  "LandingTestimonials": () => (/* reexport */ LandingTestimonials_LandingTestimonials),
  "PersuasionBannerInsurance": () => (/* reexport */ PersuasionBanner_PersuasionBannerInsurance),
  "SafenSecureTrav": () => (/* reexport */ SafenSecureTrav_SafenSecureTrav),
  "SecureTravOffer": () => (/* reexport */ SecureTravOffer_SecureTravOffer),
  "SelectCountryCodeModal": () => (/* reexport */ SelectCountryModal_SelectCountryCodeModal),
  "SelectCountryModal": () => (/* reexport */ SelectCountryModal_SelectCountryModal),
  "SelectCountryModalSheet": () => (/* reexport */ SelectCountryModal_SelectCountryModalSheet),
  "SeoContent": () => (/* reexport */ SeoContent_SeoContent),
  "TravellingTo": () => (/* reexport */ TravelDetails_TravellingTo),
  "TravellingToShimmer": () => (/* reexport */ TravellingToShimmer/* default */.Z),
  "TravellingToWidget": () => (/* reexport */ TravellingToWidget_TravellingToWidget),
  "WhatsCovered": () => (/* reexport */ WhatsCovered_WhatsCovered),
  "WhyBuyTravIns": () => (/* reexport */ WhyBuyTravIns_WhyBuyTravIns)
});

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/Breadcrumb.style.ts


const BreadcrumbNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbNav",
  componentId: "hea2ec-0"
})(["width:100%;"]);
const BreadcrumbContainer = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbContainer",
  componentId: "hea2ec-1"
})(["display:flex;align-items:center;list-style:none;padding:0;background:transparent;width:1200px;margin:0 auto;@media ", "{padding:0 20px;width:auto;margin:0;}"], src.deviceType.mobile);
const BreadcrumbItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbItem",
  componentId: "hea2ec-2"
})(["color:#000;font-size:14px;font-weight:400;", " @media ", "{font-size:12px;}"], props => props.isActive && `
    font-weight: 500;
  `, src.deviceType.mobile);
const BreadcrumbLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbLink",
  componentId: "hea2ec-3"
})(["color:#000;text-decoration:none;cursor:pointer;&:hover{text-decoration:underline;}&:visited{color:#000;}"]);
const BreadcrumbSeparator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Breadcrumbstyle__BreadcrumbSeparator",
  componentId: "hea2ec-4"
})(["color:#000;margin:0 8px;font-size:14px;user-select:none;@media ", "{margin:0 6px;font-size:12px;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/Breadcrumb.tsx






const Breadcrumb = ({
  className,
  hostname: propHostname
}) => {
  const router = (0,next_router.useRouter)(); // Get current path and hostname

  const currentPath = router.asPath; // Remove query parameters to get clean pathname

  const pathname = currentPath.split("?")[0];
  const hostname = propHostname || ( true ? window.location.hostname : 0);

  const generateBreadcrumbs = () => {
    const breadcrumbs = []; // Always add Home as first breadcrumb

    breadcrumbs.push({
      label: "Home",
      href: `https://${hostname}/`,
      isActive: false
    }); // Check if we're on travel insurance page

    if (pathname.includes("/travel-insurance")) {
      // Check if there's a country in the path
      const countryMatch = pathname.match(/\/travel-insurance\/([^/?]+)/);
      const isOnCountryPage = countryMatch && countryMatch[1];
      const isOnTravelInsurancePage = pathname === "/travel-insurance" || pathname === "/travel-insurance/";
      breadcrumbs.push({
        label: "Travel Insurance",
        href: isOnTravelInsurancePage ? null : `https://${hostname}/travel-insurance/`,
        // No link if already on travel insurance page
        isActive: isOnTravelInsurancePage // Active only if on main travel insurance page

      }); // Add country breadcrumb if on country page

      if (isOnCountryPage) {
        const countrySlug = countryMatch[1]; // Convert slug to readable country name (capitalize first letter)

        const countryName = countrySlug.charAt(0).toUpperCase() + countrySlug.slice(1);
        breadcrumbs.push({
          label: countryName,
          href: null,
          // No link for current page
          isActive: true
        });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length <= 1) {
    return null; // Don't show breadcrumb if only home exists
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbNav, {
    "aria-label": "Breadcrumb",
    className: className,
    "data-test-id": "Breadcrumb-BreadcrumbNav",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbContainer, {
      "data-test-id": "Breadcrumb-BreadcrumbContainer",
      children: breadcrumbs.map((breadcrumb, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbItem, {
          isActive: breadcrumb.isActive,
          "aria-current": breadcrumb.isActive ? "page" : undefined,
          "data-test-id": "Breadcrumb-BreadcrumbItem",
          children: breadcrumb.href ? /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbLink, {
            href: breadcrumb.href,
            onClick: e => {
              e.preventDefault();

              if (breadcrumb.href) {
                window.location.href = breadcrumb.href;
              }
            },
            "data-test-id": "Breadcrumb-BreadcrumbLink",
            children: breadcrumb.label
          }) : breadcrumb.label
        }), index < breadcrumbs.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbSeparator, {
          "aria-hidden": "true",
          "data-test-id": "Breadcrumb-BreadcrumbSeparator",
          children: ">"
        })]
      }, index))
    })
  });
};

/* harmony default export */ const Breadcrumb_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/Breadcrumb/index.tsx

// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 2 modules
var hooks = __webpack_require__(48619);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimYourInsurance.style.ts




const ClaimYourInsuranceStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimYourInsuranceStyle",
  componentId: "sc-1iy9j2p-0"
})(["background:#f6f6f6;width:100%;padding:100px 0;@media ", "{padding:48px 16px;", "{> ", "{overflow-y:auto;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;-webkit-overflow-scrolling:touch;}}}"], src.deviceType.mobile, ui_widgets_src/* InnerContentWrap */.IY, components/* FlexCompStyle */.lL);
const ClaimStructureStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimStructureStyle",
  componentId: "sc-1iy9j2p-1"
})(["background:#ffffff;border-radius:18.9111px;padding:30px 20px;display:flex;flex-direction:column;gap:16px;width:226px;position:relative;flex-shrink:0;> img{flex-shrink:0;position:absolute;right:-34%;top:40%;}@media ", "{padding:16px;width:180px;> img{right:-21%;}}"], src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimStructure.tsx









const ClaimStructure = ({
  claimIndex,
  claimInfo,
  showSpiral
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ClaimStructureStyle, {
    "data-test-id": "ClaimStructure-ClaimStructureStyle",
    children: [context === src.PARTNER.MMT ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H2Tag",
      children: claimIndex
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3Tag */.AI, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H3Tag",
      children: claimIndex
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
      "data-test-id": "ClaimStructure-SpanTag",
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RichText */.Ho, {
        value: claimInfo,
        "data-test-id": "ClaimStructure-RichText"
      })]
    }), !showSpiral && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
      width: device == "lg" ? "57px" : "24px",
      height: device == "lg" ? "57px" : "24px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/grey_Spiral_de40650b4c.svg",
      "data-test-id": "ClaimStructure-ImageComponent"
    })]
  });
};

/* harmony default export */ const ClaimYourInsurance_ClaimStructure = (ClaimStructure);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ClaimYourInsurance/ClaimYourInsurance.tsx










const ClaimYourInsurance = ({
  data,
  title,
  info
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsuranceStyle, {
    "data-test-id": "ClaimYourInsurance-ClaimYourInsuranceStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "ClaimYourInsurance-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          color: Global/* theme.greenText */.rS.greenText,
          margin: "0 0 86px",
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
          color: Global/* theme.greenText5 */.rS.greenText5,
          margin: "0 0 20px",
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? "100px" : "48px",
        padding: "0 0 20px 0",
        "data-test-id": "ClaimYourInsurance-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsurance_ClaimStructure, {
              claimInfo: item.claimInfo,
              claimIndex: item.claimIndex,
              showSpiral: index == data.length - 1,
              "data-test-id": `ClaimYourInsurance-ClaimStructure-${index}`
            }, index)
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const ClaimYourInsurance_ClaimYourInsurance = (ClaimYourInsurance);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DomesticTravelDetail/DomesticTravelDetail.style.ts

const DomesticTripStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__DomesticTripStyle",
  componentId: "uoelnx-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:8px;"]);
const ContainerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__ContainerStyle",
  componentId: "uoelnx-1"
})(["display:flex;", ";", ";"], props => props.flexDirection && `flex-direction: ${props.flexDirection}`, props => props.gap && `gap: ${props.gap}`);
const TagStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__TagStyle",
  componentId: "uoelnx-2"
})(["color:#ffffff;padding:2px 8px 2px 8px;font-weight:600;font-size:10px;align-items:center;border-radius:8px 0px 8px 0px;", ";"], props => `background: linear-gradient(45deg, ${props?.startColor ?? "#00d2ff"} 14.64%, ${props?.endColor ?? "#3a7bd5"} 85.36%)`);
const ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__ArrowButtonWrap",
  componentId: "uoelnx-3"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
const BannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__BannerStyle",
  componentId: "uoelnx-4"
})(["display:flex;background:#eaf5ff;padding:8px 15px 12px 16px;border-radius:0px 0px 8px 8px;gap:8px;font-size:14px;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DomesticTravelDetail/DomesticTrip.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









const analytics = (0,insurance/* getAnalytics */.I)();

const DomesticTrip = ({
  trips,
  title
}) => {
  (0,react.useEffect)(() => {
    analytics?.trackLandingEvents({
      actionType: "upcoming_domestic_trips_shown"
    }, "pageView");
  }, []);
  const tripData = trips?.[0];

  const handleDomesticClick = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(searchParams.entries());

    const params = _objectSpread(_objectSpread({}, queryParams), {}, {
      isUpcomingTrip: true,
      bookingId: trips?.[0]?.bookingId
    });

    analytics?.trackLandingEvents({
      actionType: "upcoming_domestic_trips_clicked"
    } //"click"
    );
    navigation/* navigationActionsSeo.navigateToTravellerDetails */.Ro.navigateToTravellerDetails(params);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerStyle, {
    flexDirection: "column",
    gap: "10px",
    "data-test-id": "DomesticTrip-ContainerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
      value: title,
      baseStyle: {
        color: Global/* theme.blackText */.rS.blackText
      },
      "data-test-id": "DomesticTrip-FormattedText"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DomesticTripStyle, {
      "data-test-id": "DomesticTrip-DomesticTripStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
        "data-test-id": "DomesticTrip-ContainerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagStyle, {
          startColor: tripData?.tag?.startColor,
          endColor: tripData?.tag?.endColor,
          "data-test-id": "DomesticTrip-TagStyle",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: tripData?.tag?.title,
            "data-test-id": "DomesticTrip-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 15px 12px 16px",
        handleClick: handleDomesticClick,
        "data-test-id": "DomesticTrip-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          "data-test-id": "DomesticTrip-SpanTag",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: tripData?.description,
            baseStyle: {
              color: "#4A4A4A",
              fontWeight: "400px",
              fontSize: "12px"
            },
            "data-test-id": "DomesticTrip-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
            margin: "7px 0px 0px 0px",
            isCursorPointer: true,
            "data-test-id": "DomesticTrip-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "32px",
              height: "32px",
              margin: "0px 8px 0px 0px",
              src: tripData?.image,
              "data-test-id": "DomesticTrip-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: tripData?.title,
                baseStyle: {
                  color: "#000000",
                  fontWeight: "700",
                  fontSize: "14px"
                },
                "data-test-id": "DomesticTrip-FormattedText"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
                "data-test-id": "DomesticTrip-ContainerStyle",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: tripData?.subtitle,
                  baseStyle: {
                    color: "#4A4A4A",
                    fontWeight: "400",
                    fontSize: "12px"
                  },
                  "data-test-id": "DomesticTrip-FormattedText"
                })
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButtonWrap, {
          "data-test-id": "DomesticTrip-ArrowButtonWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "9px",
            height: "9px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
            "data-test-id": "DomesticTrip-ImageComponent"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BannerStyle, {
        "data-test-id": "DomesticTrip-BannerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: tripData?.banner?.description,
          "data-test-id": "DomesticTrip-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const DomesticTravelDetail_DomesticTrip = (DomesticTrip);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/ExclusiveOffers.style.ts




const ExclusiveOffersStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__ExclusiveOffersStyle",
  componentId: "sc-11fj0jf-0"
})(["width:100%;background:", ";position:relative;z-index:1;overflow:hidden;display:flex;", "{width:64%;}@media ", "{padding:0 16px;}"], Global/* theme.whiteText */.rS.whiteText, components/* H2TagStyle */.FI, src.deviceType.mobile);
const OfferItemStyle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ExclusiveOffersstyle__OfferItemStyle",
  componentId: "sc-11fj0jf-1"
})(["display:inline-block;background-color:", ";border-radius:8px;width:450px;height:220px;flex-shrink:0;overflow:hidden;@media ", "{width:286px;height:180px;border-radius:16px;", "}"], Global/* theme.whiteText */.rS.whiteText, src.deviceType.mobile, p => p.singleItem && `
      width: calc(100vw - 32px);
      height: calc((100vw - 32px) / 1.5888888888888888);
    `);
const OffersWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__OffersWrap",
  componentId: "sc-11fj0jf-2"
})(["display:flex;align-items:center;gap:20px;overflow-x:auto;margin-left:-16px;padding-left:16px;margin-right:-16px;padding-right:16px;"]);
const SliderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderWrap",
  componentId: "sc-11fj0jf-3"
})(["display:flex;padding-left:7px;padding-top:7px;"]);
const SlidesBtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SlidesBtnWrap",
  componentId: "sc-11fj0jf-4"
})(["box-shadow:0px 1px 7px 0px #00000033;background-color:", ";border-radius:100px;padding:4px 14px;width:72px;height:28px;display:flex;align-items:center;justify-content:space-between;"], Global/* theme.whiteText */.rS.whiteText);
const SliderArrowLeft = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowLeft",
  componentId: "sc-11fj0jf-5"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(135deg);-webkit-transform:rotate(135deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, p => p.disable && `opacity: 0.5;`);
const SliderArrowRight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowRight",
  componentId: "sc-11fj0jf-6"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, p => p.disable && `opacity: 0.5;`);
const SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderContainer",
  componentId: "sc-11fj0jf-7"
})(["overflow:hidden;width:100%;position:relative;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/OfferItem.tsx




const aspectRatio = (/* unused pure expression or super */ null && (286 / 180));

const OfferItem = ({
  cta,
  image_url,
  handleClickOfferItem,
  offerItemLength
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OfferItemStyle, {
    onClick: handleClickOfferItem,
    href: cta.url,
    rel: "noreferrer",
    target: "_blank",
    singleItem: offerItemLength == 1 && device == "sm",
    "data-test-id": "OfferItem-OfferItemStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
      src: image_url,
      width: "100%",
      height: "100%",
      "data-test-id": "OfferItem-ImageTag"
    })
  });
};

/* harmony default export */ const ExculsiveOffers_OfferItem = (OfferItem);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/ExculsiveOffers/ExclusiveOffers.tsx









const ExclusiveOffers_analytics = (0,insurance/* getAnalytics */.I)();

const ExclusiveOffers = ({
  data
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: currentSlide,
    1: setCurrentSlide
  } = (0,react.useState)(0);

  const handleNext = () => {
    if (currentSlide < data.items.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  (0,react.useEffect)(() => {
    data.items.forEach((item, index) => {
      const element = document.getElementById(`slide${index}`);
      const observer = new IntersectionObserver(obCallback, {
        threshold: 1
      });
      element && observer.observe(element);

      function obCallback(entries) {
        if (entries[0].isIntersecting) {
          ExclusiveOffers_analytics?.trackLandingEvents({
            actionType: `offer_banner${index + 1}_shown`
          } // "click"
          );
          (0,XDMAnalytics.trackComponentView)({
            name: `offer_banner_${index + 1}_shown`,
            type: "offers"
          });
        }
      }
    });
  }, [data.items]);

  const handleClickOfferItem = index => {
    ExclusiveOffers_analytics?.trackLandingEvents({
      actionType: `offer_banner${index + 1}_clicked`
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `offer_banner_${index + 1}_clicked`
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ExclusiveOffersStyle, {
    "data-test-id": "ExclusiveOffers-ExclusiveOffersStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "ExclusiveOffers-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        margin: "0 0 60px",
        alignItems: "center",
        justifyContent: "space-between",
        "data-test-id": "ExclusiveOffers-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
          "data-test-id": "ExclusiveOffers-H2Tag",
          children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: data.title,
            "data-test-id": "ExclusiveOffers-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlidesBtnWrap, {
          "data-test-id": "ExclusiveOffers-SlidesBtnWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowLeft, {
            disable: currentSlide == 0,
            onClick: handlePrev,
            "data-test-id": "ExclusiveOffers-SliderArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowRight, {
            disable: currentSlide == data.items.length - 1,
            onClick: handleNext,
            "data-test-id": "ExclusiveOffers-SliderArrowRight"
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        margin: "0 0 20px",
        "data-test-id": "ExclusiveOffers-H5Tag",
        children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: data.title,
          "data-test-id": "ExclusiveOffers-FormattedText"
        })
      }), device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(OffersWrap, {
        "data-test-id": "ExclusiveOffers-OffersWrap",
        children: data.items && data.items.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: `slide${index}`,
            "data-test-id": `ExclusiveOffers-${index}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
              handleClickOfferItem: () => handleClickOfferItem(index),
              cta: item.cta,
              image_url: item.image_url,
              offerItemLength: data.items.length,
              "data-test-id": "ExclusiveOffers-OfferItem"
            })
          }, index);
        })
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SliderContainer, {
        "data-test-id": "ExclusiveOffers-SliderContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SliderWrap, {
          style: {
            transform: `translateX(-${currentSlide * 42}%)`,
            transition: "transform 0.5s ease-in-out"
          },
          "data-test-id": "ExclusiveOffers-SliderWrap",
          children: data.items && data.items.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: `slide${index}`,
              style: {
                marginRight: 20
              },
              "data-test-id": `ExclusiveOffers-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
                handleClickOfferItem: () => handleClickOfferItem(index),
                cta: item.cta,
                image_url: item.image_url,
                "data-test-id": "ExclusiveOffers-OfferItem"
              })
            }, index);
          })
        })
      })]
    })
  });
};

/* harmony default export */ const ExculsiveOffers_ExclusiveOffers = (ExclusiveOffers);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InsuranceStats/InsuranceStats.style.ts


const InsuranceStatsWrap = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsWrap",
  componentId: "sc-1qor9fz-0"
})(["width:100%;@media ", "{padding:0 16px;}"], src.deviceType.mobile);
const InsuranceStatsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsStyle",
  componentId: "sc-1qor9fz-1"
})(["background:#fff;border-radius:16px;padding:40px 80px;display:flex;gap:114px;width:1200px;margin:0 auto;position:relative;z-index:1;display:grid;grid-template-columns:repeat(4,1fr);box-shadow:0px 3px 30px rgba(0,0,0,0.1);", " @media ", "{width:100%;gap:24px;padding:16px;grid-template-columns:repeat(2,1fr);box-shadow:none;", "}"], p => p.pageTheme === src.PARTNER.GI && `
    border-radius: 20px;
    background: #FFF;
    `, src.deviceType.mobile, p => p.pageTheme === src.PARTNER.GI && `
    background: #fff;
    box-shadow:none;
    `);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InsuranceStats/InsuranceStats.tsx







const InsuranceStats = ({
  data
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsWrap, {
    id: "insurance-stats",
    "data-test-id": "InsuranceStats-InsuranceStatsWrap",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsStyle, {
      pageTheme: context ? context : undefined,
      "data-test-id": "InsuranceStats-InsuranceStatsStyle",
      children: data && data.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "data-test-id": `InsuranceStats-${index}`,
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H4Tag */.j9, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H4Tag",
            children: item.title
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H5Tag",
            children: item.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: device == "lg" ? "md" : "xs",
            "data-test-id": "InsuranceStats-ParaTag",
            children: item.info
          })]
        }, index);
      })
    })
  });
};

/* harmony default export */ const InsuranceStats_InsuranceStats = (InsuranceStats);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/InterlinkingBlock.style.ts



const InterlinkingBlockStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "InterlinkingBlockstyle__InterlinkingBlockStyle",
  componentId: "sc-18rfz75-0"
})(["background:", ";color:", ";padding:20px 0;width:100%;"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.blackText */.rS.blackText);
const InterlinkingBlockWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__InterlinkingBlockWrap",
  componentId: "sc-18rfz75-1"
})(["margin:0 auto;max-width:1200px;padding:0 20px;@media screen and ", "{padding:0 16px;}"], src.deviceType.mobile);
const SectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__SectionContainer",
  componentId: "sc-18rfz75-2"
})(["display:flex;flex-direction:column;gap:40px;& > *:last-child{gap:0;}@media screen and ", "{gap:30px;& > *:last-child{gap:0;}}"], src.deviceType.mobile);
const Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__Section",
  componentId: "sc-18rfz75-3"
})(["display:flex;flex-direction:column;"]);
const SectionTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "InterlinkingBlockstyle__SectionTitle",
  componentId: "sc-18rfz75-4"
})(["color:", ";font-size:14px;font-weight:700;margin-bottom:8px;line-height:1.4;text-transform:uppercase;letter-spacing:0.5px;@media screen and ", "{font-size:13px;margin-bottom:6px;}"], Global/* theme.blackText */.rS.blackText, src.deviceType.mobile);
const LinksContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InterlinkingBlockstyle__LinksContainer",
  componentId: "sc-18rfz75-5"
})(["line-height:1.6;text-align:justify;"]);
const LinkItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InterlinkingBlockstyle__LinkItem",
  componentId: "sc-18rfz75-6"
})(["&:not(:last-child):after{content:\", \";color:", ";}"], Global/* theme.blackText */.rS.blackText);
const Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "InterlinkingBlockstyle__Link",
  componentId: "sc-18rfz75-7"
})(["color:", ";text-decoration:none;font-size:13px;font-weight:400;line-height:1.6;transition:color 0.2s ease;&:hover{color:", ";text-decoration:underline;}@media screen and ", "{font-size:12px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.blackText */.rS.blackText || "#007bff", src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/InterlinkingBlock.tsx





const InterlinkingBlock = ({
  interlinkingBlock = []
}) => {
  if (!interlinkingBlock || interlinkingBlock.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(InterlinkingBlockStyle, {
    "data-test-id": "InterlinkingBlock-InterlinkingBlockStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InterlinkingBlockWrap, {
      "data-test-id": "InterlinkingBlock-InterlinkingBlockWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionContainer, {
        "data-test-id": "InterlinkingBlock-SectionContainer",
        children: interlinkingBlock?.map((section, sectionIndex) => /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          className: `${sectionIndex}`,
          "data-test-id": "InterlinkingBlock-Section",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle, {
            "data-test-id": "InterlinkingBlock-SectionTitle",
            children: section?.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinksContainer, {
            "data-test-id": "InterlinkingBlock-LinksContainer",
            children: section?.links?.map((link, linkIndex) => /*#__PURE__*/(0,jsx_runtime.jsx)(LinkItem, {
              "data-test-id": "InterlinkingBlock-LinkItem",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
                href: link?.url,
                rel: "noopener noreferrer",
                "data-test-id": "InterlinkingBlock-Link",
                children: link.title
              })
            }, `link-${sectionIndex}-${linkIndex}`))
          })]
        }, `section-${sectionIndex}`))
      })
    })
  });
};

/* harmony default export */ const InterlinkingBlock_InterlinkingBlock = (InterlinkingBlock);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/InterlinkingBlock/index.tsx

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var static_components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFaq/LandingFaq.style.ts



const LandingFaqStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFaqstyle__LandingFaqStyle",
  componentId: "sc-1sfu3od-0"
})(["", " display:flex;background:#fff;flex-direction:column;width:100%;", ""], props => props.margin && `margin: ${props.margin};`, props => props.customFaq && ``);
const LandingFaqTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqTitle",
  componentId: "sc-1sfu3od-1"
})(["font-family:\"Lato\";font-weight:400;font-size:36px;line-height:56px;margin-left:", ";margin-bottom:", ";color:", ";@media screen and ", "{font-weight:500;font-size:24px;line-height:32px;margin-bottom:8px;margin-left:", ";}"], props => props.marginLeft ? props.marginLeft : "0px", props => props.marginBottom ? props.marginBottom : "56px", Global/* theme.blackText */.rS.blackText, utils/* deviceType.mobile */.vO.mobile, props => props.marginLeft ? props.marginLeft : "0px");
const LandingFaqList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFaqstyle__LandingFaqList",
  componentId: "sc-1sfu3od-2"
})(["width:1000px;gap:16px;li{margin-bottom:16px;position:relative;cursor:pointer;}li h3{padding:24px;@media screen and ", "{padding:16px;}}li p{padding:0 24px 24px;}li .faq-content{max-height:0;overflow:hidden;opacity:0;padding:0 24px;}li.open .faq-content{max-height:10000px;opacity:1;padding:0 24px 24px;}li:after{content:\"\";position:absolute;border:solid black;border-width:0 3px 3px 0;display:inline-block;padding:3px;right:24px;top:33px;transition:0.3s ease-in;@media screen and ", "{top:16px;}}li.close:after{transform:rotate(45deg);-webkit-transform:rotate(45deg);}li.open:after{transform:rotate(-135deg);-webkit-transform:rotate(-135deg);}li:hover{background:#ffffff;box-shadow:0px 4px 16px rgba(0,0,0,0.16);border-radius:6px;}li:last-child{margin-bottom:unset;}", " @media screen and ", "{width:100%;}"], utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.mobile */.vO.mobile, props => props.customFaq && `
            width:100%;
            gap:8px;
            margin-bottom: 24px;
            li {
                padding: 12px 16px;
                background: #FFFFFF;
                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
                border-radius: 6px;
            }
            li h3 {
                padding: unset;
            }
            li p {
                padding:unset;
                font-size: 12px;
                line-height: 16px;
                color: #000000;
            }
            li:after {
                border: solid #008CFF;
                border-width: 0 2px 2px 0;
                padding: 4px;
                right: 24px;
                top: 13px;
            }
    `, utils/* deviceType.mobile */.vO.mobile);
const LandingFaqQues = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqQues",
  componentId: "sc-1sfu3od-3"
})(["font-weight:700;font-size:22px;line-height:30px;color:#000;", " @media screen and ", "{font-weight:700;font-size:16px;line-height:20px;}"], props => props.customFaq && `
        font-size: 12px;
        line-height: 16px;
        color: #000000;`, utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFaq/LandingFaq.tsx








const LandingFaq = ({
  customTitle,
  customFaq,
  faq,
  margin
}) => {
  const {
    0: exp,
    1: setExp
  } = (0,react.useState)(-1);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  const handleClick = index => {
    exp != index ? setExp(index) : setExp(-1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqStyle, {
    margin: margin,
    customFaq: customFaq,
    "data-test-id": "LandingFaq-LandingFaqStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "LandingFaq-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.H2Tag, {
        margin: "0 0 24px 0",
        "data-test-id": "LandingFaq-H2Tag",
        children: customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingFaq-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.H5Tag, {
        margin: "0 0 24px 16px",
        "data-test-id": "LandingFaq-H5Tag",
        children: customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingFaq-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqList, {
        customFaq: customFaq,
        "data-test-id": "LandingFaq-LandingFaqList",
        children: faq.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: `${exp == index ? "open" : "close"}`,
            onClick: () => handleClick(index),
            "data-test-id": `LandingFaq-${index}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqQues, {
              customFaq: customFaq,
              "data-test-id": "LandingFaq-LandingFaqQues",
              children: item.ques && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.ques,
                "data-test-id": "LandingFaq-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "faq-content",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.info,
                baseStyle: {
                  whiteSpace: "pre-line"
                },
                "data-test-id": "LandingFaq-FormattedText"
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const LandingFaq_LandingFaq = (LandingFaq);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFooter/LandingFooter.style.ts



const LandingFooterStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFooterstyle__LandingFooterStyle",
  componentId: "sc-14d61ct-0"
})(["background:", ";color:", ";padding-top:32px;padding-bottom:64px;width:100%;@media screen and ", "{padding-bottom:22px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.whiteText */.rS.whiteText, src.deviceType.mobile);
const ChevronContainerIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingFooterstyle__ChevronContainerIcon",
  componentId: "sc-14d61ct-1"
})(["transform:", ";"], props => props.isInvert ? "rotate(180deg)" : "rotate(0deg)");
const LandingFooter_style_LinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__LinksContainer",
  componentId: "sc-14d61ct-2"
})(["margin-bottom:", ";& > li:not(:last-child){margin-bottom:24px;}@media screen and ", "{margin-bottom:40px;& > li{padding:16px;border-bottom:1px ", " solid;}& > li:not(:last-child){margin-bottom:unset;}}"], p => p.isCopyrightText ? "100px" : "0", src.deviceType.mobile, Global/* theme.greyText */.rS.greyText);
const FooterSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__FooterSection",
  componentId: "sc-14d61ct-3"
})(["width:964px;@media screen and ", "{width:100%;}"], src.deviceType.mobile);
const InnerLinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__InnerLinksContainer",
  componentId: "sc-14d61ct-4"
})(["display:flex;margin-top:10px;flex-wrap:wrap;& > li{position:relative;color:white;font-size:12px;line-height:16px;}& > li::after{content:\"\u2022\";margin-left:4px;margin-right:4px;}& > li:last-child:after{content:\"\";}"]);
const LandingFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterWrap",
  componentId: "sc-14d61ct-5"
})(["margin:0 auto;width:1200px;@media screen and ", "{width:100%;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/icons/index.tsx + 8 modules
var icons = __webpack_require__(51046);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingFooter/LandingFooter.tsx








const LandingFooter = ({
  footerData,
  followUsText = "FOLLOW US",
  downloadText = "DOWNLOAD",
  countryText = "Country",
  locationText = "INDIA",
  mmtText = "MAKEMYTRIP PVT. LTD.",
  playStoreImgURI,
  appStoreImgURI,
  linkedInImgURI,
  facebookImgURI,
  twitterImgURI,
  downIcon,
  footerHeartIcon,
  footerHeading,
  footerCopyrightData
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: activeIdx,
    1: setActiveIdx
  } = (0,react.useState)(-1);
  let footerTextOne = "";
  let headerAlt = "";
  let headerImg = "";
  let footerTextTwo = "";
  const regex = /^(.*?)!\[(.*?)\]\((.*?)\)(.*?)$/;
  const match = footerHeading?.value?.match(regex);

  if (match) {
    footerTextOne = match[1].trim();
    headerAlt = match[2].trim();
    headerImg = match[3].trim();
    footerTextTwo = match[4].trim();
  }

  const copyrightText = footerCopyrightData?.items?.find(item => item.type === "copyright")?.value;

  const optionsHandler = index => {
    if (activeIdx === index) {
      setActiveIdx(-1);
      return;
    }

    setActiveIdx(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooterStyle, {
    "data-test-id": "LandingFooter-LandingFooterStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooterWrap, {
      "data-test-id": "LandingFooter-LandingFooterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FooterSection, {
        "data-test-id": "LandingFooter-FooterSection",
        children: [footerHeading && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
          alignItems: "center",
          justifyContent: device === "sm" ? "center" : undefined,
          margin: "0px 0px 50px 0px",
          "data-test-id": "LandingFooter-FlexComp",
          children: [footerTextOne && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 8px 4px 0px",
            color: "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextOne
          }), headerImg ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "85px",
            height: "27px",
            src: headerImg,
            alt: headerAlt,
            "data-test-id": "LandingFooter-ImageComponent"
          }) : null, footerTextTwo && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 0px 4px 8px",
            color: "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextTwo
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooter_style_LinksContainer, {
          isCopyrightText: !!copyrightText,
          "data-test-id": "LandingFooter-LinksContainer",
          children: footerData?.map((item, idx) => {
            return item?.label && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              onClick: device === "sm" ? () => optionsHandler(idx) : undefined,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                justifyContent: device === "sm" ? "space-between" : undefined,
                gap: "8px",
                alignItems: "center",
                "data-test-id": "LandingFooter-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                  gap: "10px",
                  "data-test-id": "LandingFooter-FlexComp",
                  children: [item?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                    width: "18px",
                    height: "18px",
                    src: item.icon,
                    "data-test-id": "LandingFooter-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
                    color: "white",
                    fontWeight: "black",
                    "data-test-id": "LandingFooter-ParaTag",
                    children: item.label
                  })]
                }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronContainerIcon, {
                  isInvert: activeIdx !== idx,
                  "data-test-id": "LandingFooter-ChevronContainerIcon",
                  children: downIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
                    src: downIcon,
                    "data-test-id": "LandingFooter-ImageTag"
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* ChevronUpIcon */.g8, {
                    "data-test-id": "LandingFooter-ChevronUpIcon"
                  })
                })]
              }), device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map(point => {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    "data-test-id": "LandingFooter",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      "data-test-id": "LandingFooter-AnchorTag",
                      children: point.label
                    })
                  }, point.id);
                })
              }) : activeIdx === idx && /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map(point => {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    "data-test-id": "LandingFooter",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      "data-test-id": "LandingFooter-AnchorTag",
                      children: point.label
                    })
                  }, point.id);
                })
              })]
            }, item.id);
          })
        })]
      }), copyrightText && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        flexDirection: device === "sm" ? "column" : undefined,
        justifyContent: "space-between",
        "data-test-id": "LandingFooter-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            textAlign: device === "lg" ? "right" : "center"
          },
          dangerouslySetInnerHTML: {
            __html: copyrightText.replace(/\n/g, "<br />")
          }
        })
      })]
    })
  });
};

/* harmony default export */ const LandingFooter_LandingFooter = (LandingFooter);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingTestimonials/LandingTestimonials.style.ts



const LandingTestimonialsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestimonialsStyle",
  componentId: "sc-1e4zunl-0"
})(["display:flex;background:#fff;flex-direction:column;margin-bottom:137px;width:100%;@media ", "{margin-bottom:40px;}"], src.deviceType.mobile);
const LandingTestTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestTitle",
  componentId: "sc-1e4zunl-1"
})(["font-family:\"Lato\";font-weight:500;font-size:56px;line-height:72px;color:#000000;margin-bottom:34px;display:flex;align-items:center;@media ", "{font-size:24px;line-height:32px;margin-bottom:12px;padding:0px 16px;}"], src.deviceType.mobile);
const TestimonialContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialContent",
  componentId: "sc-1e4zunl-2"
})(["display:flex;margin-bottom:8px;> img{margin-right:17px;border-radius:8px;}"]);
const LandingTest = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTest",
  componentId: "sc-1e4zunl-3"
})(["display:inline-block;img{object-fit:contain;}@media ", "{font-weight:400;color:#4a4a4a;align-items:flex-start;border-radius:10px;position:relative;background:#fff;z-index:1;width:100% !important;flex-direction:column !important;padding:4px 16px;font-size:14px;line-height:20px;}"], src.deviceType.mobile);
const LandingTestWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestWrap",
  componentId: "sc-1e4zunl-4"
})(["display:flex;width:575px;padding:32px 30px;background:#fff;position:relative;z-index:1;border-radius:10px;margin-right:20px;", "{white-space:initial;}@media ", "{width:unset;padding:16px;", "{font-size:14px;line-height:20px;}box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:10px;margin-right:unset;}"], components/* ParaTagStyle */.OG, src.deviceType.mobile, components/* ParaTagStyle */.OG);
const LandingTestImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestImg",
  componentId: "sc-1e4zunl-5"
})(["width:150px;height:250px;flex-shrink:0;position:relative;margin-right:20px;z-index:1;> img{border-radius:20px;}@media ", "{width:84px;height:87px;display:flex;}"], src.deviceType.mobile);
const LandingTextCrd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTextCrd",
  componentId: "sc-1e4zunl-6"
})(["padding:4px 8px 4px 8px;border-radius:19px;font-weight:700;font-size:12px;line-height:11px;color:#fff;position:absolute;bottom:-7px;left:25px;text-transform:uppercase;", " ", " @media ", "{position:static;width:fit-content;}"], p => p.cardType == "travelLoan" && `
    background: linear-gradient(88.44deg, #43e1a8 0.02%, #28beb2 100.01%);
    `, p => p.cardType == "forexCard" && `
    background: linear-gradient(85.23deg, #ff7f3f 0%, #ff3e5e 100%);
    `, src.deviceType.mobile);
const PersonName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__PersonName",
  componentId: "sc-1e4zunl-7"
})(["font-weight:700;font-size:24px;line-height:36px;color:#012136;margin-bottom:2px;display:block;@media ", "{font-size:16px;line-height:20px;font-weight:900;}"], src.deviceType.mobile);
const LandingTestimonials_style_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__Date",
  componentId: "sc-1e4zunl-8"
})(["font-weight:400;font-size:14px;line-height:18px;color:#9b9b9b;@media ", "{font-size:12px;}"], src.deviceType.mobile);
const LandingTestCntnt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestCntnt",
  componentId: "sc-1e4zunl-9"
})(["z-index:1;@media ", "{white-space:initial;}"], src.deviceType.mobile);
const Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__Flex",
  componentId: "sc-1e4zunl-10"
})(["display:flex;width:100%;margin-bottom:8px;"]);
const SlideShowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowContainer",
  componentId: "sc-1e4zunl-11"
})(["margin:0 auto;overflow:hidden;max-width:1200px;@media ", "{max-width:100%;cursor:grab;}"], src.deviceType.mobile);
const SlideShowSLider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowSLider",
  componentId: "sc-1e4zunl-12"
})(["white-space:nowrap;transition:ease 1000ms;"]);
const SlideDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideDots",
  componentId: "sc-1e4zunl-13"
})(["text-align:center;@media ", "{margin-top:12px;}"], src.deviceType.mobile);
const SlideShowDotItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowDotItem",
  componentId: "sc-1e4zunl-14"
})(["background:#3f3d56;opacity:0.2;width:12px;height:12px;border-radius:100%;display:inline-block;margin-right:16px;cursor:pointer;", ""], p => p.active && `
        width: 32px;
        height: 12px;
        background: #000000 !important;
        opacity: 1;
        border-radius: 6px;
        `);
const StarRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRating",
  componentId: "sc-1e4zunl-15"
})(["display:flex;gap:8px;", " @media ", "{gap:5px;}"], p => p.starRateFull && `
    position: absolute;
    top: 0;
    `, src.deviceType.mobile);
const StarRatingWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRatingWrap",
  componentId: "sc-1e4zunl-16"
})(["margin-bottom:12px;position:relative;"]);
const TestimonialTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialTag",
  componentId: "sc-1e4zunl-17"
})(["background:rgba(120,198,255,0.2);border:1px solid rgba(120,198,255,0.4);border-radius:8px;padding:2px 12px;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/LandingTestimonials/LandingTestimonials.tsx









const LandingTestimonials = ({
  customTitle,
  test
}) => {
  const {
    0: currentIndex,
    1: setCurrentIndex
  } = (0,react.useState)(0);
  const {
    0: length,
    1: setLength
  } = (0,react.useState)(test?.length);
  const {
    0: touchPosition,
    1: setTouchPosition
  } = (0,react.useState)(null);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: isHovered,
    1: setIsHovered
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setLength(test?.length);
  }, [test]);

  const next = () => {
    if (currentIndex < length - 1) {
      setCurrentIndex(prevState => prevState + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prevState => prevState - 1);
    }
  };

  const handleTouchStart = e => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = e => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);

    if (isHovered) {
      resetTimeout();
    }
  };

  const timeoutRef = react.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  react.useEffect(() => {
    resetTimeout();
    timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
    return () => {
      resetTimeout();
      timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
    };
  }, [currentIndex]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    resetTimeout();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    resetTimeout();
    timeoutRef.current = window.setTimeout(() => setCurrentIndex(prevIndex => prevIndex === test?.length - 1 ? 0 : prevIndex + 1), 2500);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTestimonialsStyle, {
    "data-test-id": "LandingTestimonials-LandingTestimonialsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "LandingTestimonials-InnerContentWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestTitle, {
        "data-test-id": "LandingTestimonials-LandingTestTitle",
        children: [customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: customTitle,
          "data-test-id": "LandingTestimonials-FormattedText"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
          width: device == "lg" ? "66px" : "32px",
          height: device == "lg" ? "66px" : "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/heart_9289dd4a1d.svg",
          "data-test-id": "LandingTestimonials-ImageComponent"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideShowContainer, {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-test-id": "LandingTestimonials-SlideShowContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowSLider, {
          style: {
            transform: `translateX(-${currentIndex * (device === "lg" ? 50 : 100)}%)`
          },
          "data-test-id": "LandingTestimonials-SlideShowSLider",
          children: test && test.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTest, {
              "data-test-id": `LandingTestimonials-LandingTest-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestWrap, {
                "data-test-id": "LandingTestimonials-LandingTestWrap",
                children: [device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestImg, {
                  "data-test-id": "LandingTestimonials-LandingTestImg",
                  children: [item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                    width: "150",
                    height: "250",
                    alt: "hello",
                    src: item.personImg.src,
                    "data-test-id": "LandingTestimonials-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                    cardType: item.personCrdClass,
                    "data-test-id": "LandingTestimonials-LandingTextCrd",
                    children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.personCard,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestCntnt, {
                  "data-test-id": "LandingTestimonials-LandingTestCntnt",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TestimonialContent, {
                    "data-test-id": "LandingTestimonials-TestimonialContent",
                    children: [device !== "lg" && item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                      width: "84",
                      height: "87",
                      alt: "",
                      src: item.personImg.src
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonName, {
                        "data-test-id": "LandingTestimonials-PersonName",
                        children: item.personName && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                          value: item.personName,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StarRatingWrap, {
                        "data-test-id": "LandingTestimonials-StarRatingWrap",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: 5
                          }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarEmpty */.rj, {
                            height: device !== "lg" ? 16 : 25,
                            width: device !== "lg" ? 16 : 26,
                            "data-test-id": `LandingTestimonials-StarEmpty-${index}`
                          }, index))
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          starRateFull: true,
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: Number(item.personRating)
                          }, (_, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarFull */.Um, {
                            height: device !== "lg" ? 16 : 25,
                            width: device !== "lg" ? 16 : 26,
                            "data-test-id": `LandingTestimonials-StarFull-${index}`
                          }, index))
                        })]
                      }), device !== "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                        "data-test-id": "LandingTestimonials-LandingTextCrd",
                        children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                          value: item.personCard,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
                    fontSize: "md",
                    color: Global/* theme.greyText */.rS.greyText,
                    "data-test-id": "LandingTestimonials-ParaTag",
                    children: item.testInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.testInfo,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                })]
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDots, {
          "data-test-id": "LandingTestimonials-SlideDots",
          children: test?.map((_, idx) => /*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowDotItem, {
            active: currentIndex === idx,
            onClick: () => {
              setCurrentIndex(idx);
            },
            "data-test-id": `LandingTestimonials-SlideShowDotItem-${idx}`
          }, idx))
        })]
      })]
    })
  });
};

/* harmony default export */ const LandingTestimonials_LandingTestimonials = (LandingTestimonials);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/PersuasionBanner/PersuasionBanner.style.tsx




const PersuasionBannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionBannerstyle__PersuasionBannerStyle",
  componentId: "szyc0w-0"
})(["", " padding:30px 34px;border-radius:25px;background-image:", ";background-size:contain;background-repeat:no-repeat;display:flex;flex-direction:column;height:400px;gap:20px;em{color:", ";font-weight:700;font-style:normal;}", "{width:100%;}& ul{display:flex;flex-direction:column;gap:16px;}& li{position:relative;padding-left:16px;}& li:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}@media ", "{padding:32px 16px;background-size:cover;border:1px solid #fff;margin-bottom:16px;}", "{margin-bottom:16px;&:last-child{margin-bottom:0;}@media ", "{margin-bottom:8px;}}", "{padding:10px 40px;}"], props => props.margin && `margin: ${props.margin};`, props => `url(${props.bgImage})`, Global/* theme.greenText */.rS.greenText, components/* H3TagStyle */.KO, Global/* theme.darkYellowText */.rS.darkYellowText, src.deviceType.mobile, components/* BulletListItemStyle */.Il, src.deviceType.mobile, components/* LandingButtonStyle */.zm);
const BulletListStyle = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "PersuasionBannerstyle__BulletListStyle",
  componentId: "szyc0w-1"
})(["display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/PersuasionBanner/PersuasionBannerInsurance.tsx






const PersuasionBannerInsurance = ({
  crossSell,
  btnHandler
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  if (!crossSell) {
    return null;
  }

  const {
    title,
    background,
    description,
    cta,
    info
  } = crossSell;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PersuasionBannerStyle, {
    bgImage: background?.url,
    "data-test-id": "PersuasionBannerInsurance-PersuasionBannerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3Tag */.AI, {
      "data-test-id": "PersuasionBannerInsurance-H3Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "PersuasionBannerInsurance-FormattedText"
      })
    }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
      gap: "6px",
      "data-test-id": "PersuasionBannerInsurance-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        "data-test-id": "PersuasionBannerInsurance-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: info,
          "data-test-id": "PersuasionBannerInsurance-FormattedText"
        })
      })
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MarkdownText */.rU, {
      value: description,
      "data-test-id": "PersuasionBannerInsurance-MarkdownText"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
      customTitle: cta?.title,
      onClick: btnHandler,
      padding: "0px 40px",
      "data-test-id": "PersuasionBannerInsurance-LandingButton"
    })]
  });
};

/* harmony default export */ const PersuasionBanner_PersuasionBannerInsurance = (PersuasionBannerInsurance);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTrav.style.ts



const SafenSecureTravStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravStyle",
  componentId: "sc-1t32hx4-0"
})(["width:100%;background:#fff;position:relative;z-index:1;overflow:hidden;", "{width:64%;}@media ", "{padding:0 16px;}"], components/* H2TagStyle */.FI, src.deviceType.mobile);
const SafenSecureTravCrdStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravCrdStyle",
  componentId: "sc-1t32hx4-1"
})(["background:linear-gradient( 128.03deg,rgba(227,247,245,0.36) 2.1%,rgba(230,237,255,0.441706) 49.06%,rgba(214,232,244,0.6) 80.75% ),#fcffff;border-radius:14px;padding:24px;flex:1;position:relative;display:flex;flex-direction:column;gap:24px;> img{position:absolute;right:30px;bottom:24px;}@media ", "{gap:12px;}"], src.deviceType.mobile);
const FeatList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "SafenSecureTravstyle__FeatList",
  componentId: "sc-1t32hx4-2"
})(["display:flex;flex-direction:", ";gap:", ";max-width:80%;li{position:relative;padding-left:14px;}li:after{content:\"\";position:absolute;background:#000000;border-radius:2px;width:4px;height:14px;top:6px;left:0;}@media ", "{margin-bottom:12px;flex-direction:column;gap:16px;}"], p => p.cardQuantity === 1 ? "row" : "column", p => p.cardQuantity === 1 ? "50px" : "16px", src.deviceType.mobile);
const SafenSecureBgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureBgWrap",
  componentId: "sc-1t32hx4-3"
})(["position:absolute;top:17px;right:-122px;width:100%;z-index:-1;height:558px;img{width:100%;height:558px;}"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTravCrd.tsx






const SafenSecureTravCrd = ({
  title,
  featList,
  cardImg,
  poweredBy,
  cardQuantity
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravCrdStyle, {
    "data-test-id": "SafenSecureTravCrd-SafenSecureTravCrdStyle",
    children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3SmallTag */.vb, {
      "data-test-id": "SafenSecureTravCrd-H3SmallTag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      fontWeight: "black",
      fontSize: "large",
      margin: device == "sm" ? "" : "0 0 12px",
      "data-test-id": "SafenSecureTravCrd-ParaTag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatList, {
      cardQuantity: cardQuantity,
      "data-test-id": "SafenSecureTravCrd-FeatList",
      children: featList && featList?.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          "data-test-id": `SafenSecureTravCrd-${index}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: item,
            "data-test-id": "SafenSecureTravCrd-FormattedText"
          })
        }, index);
      })
    }), poweredBy && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      margin: "auto 0 0",
      gap: "20px",
      alignItems: "Center",
      "data-test-id": "SafenSecureTravCrd-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xs",
        "data-test-id": "SafenSecureTravCrd-SpanTag",
        children: "Powered By"
      }), poweredBy && poweredBy.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
          src: item,
          height: "32px",
          width: "auto",
          "data-test-id": `SafenSecureTravCrd-ImageComponent-${index}`
        }, index);
      })]
    }), cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
      width: device == "lg" ? "92px" : "54px",
      height: device == "lg" ? "102px" : "60px",
      src: cardImg,
      "data-test-id": "SafenSecureTravCrd-ImageComponent"
    })]
  });
};

/* harmony default export */ const SafenSecureTrav_SafenSecureTravCrd = (SafenSecureTravCrd);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SafenSecureTrav/SafenSecureTrav.tsx


function SafenSecureTrav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SafenSecureTrav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SafenSecureTrav_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SafenSecureTrav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








const SafenSecureTrav = ({
  title,
  data
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravStyle, {
    "data-test-id": "SafenSecureTrav-SafenSecureTravStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureBgWrap, {
      "data-test-id": "SafenSecureTrav-SafenSecureBgWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
        width: "100%",
        height: "558px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/safen_Secure_Bg_200cfd8d5c.svg",
        "data-test-id": "SafenSecureTrav-ImageComponent"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "SafenSecureTrav-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
        margin: "0 0 60px",
        "data-test-id": "SafenSecureTrav-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        margin: "0 0 20px",
        "data-test-id": "SafenSecureTrav-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? "60px" : "20px",
        flexDirection: device == "sm" ? "column" : "row",
        flexWrap: "wrap",
        "data-test-id": "SafenSecureTrav-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureTrav_SafenSecureTravCrd, SafenSecureTrav_objectSpread(SafenSecureTrav_objectSpread({
            cardQuantity: data?.length
          }, item), {}, {
            "data-test-id": `SafenSecureTrav-SafenSecureTravCrd-${index}`
          }), index);
        })
      })]
    })]
  });
};

/* harmony default export */ const SafenSecureTrav_SafenSecureTrav = (SafenSecureTrav);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SecureTravOffer/SecureTravOffer.style.ts



const SecureTravOfferStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravOfferStyle",
  componentId: "sc-19r9m5r-0"
})(["display:flex;flex-direction:column;gap:24px;svg{flex-shrink:0;}", "{font-size:22px;font-weight:900;}"], components/* H5TagStyle */.Wl);
const SecureTravItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravItem",
  componentId: "sc-19r9m5r-1"
})(["display:flex;gap:24px;@media ", "{gap:8px;}"], src.deviceType.mobile);
const SecureTravImgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravImgWrap",
  componentId: "sc-19r9m5r-2"
})(["background:linear-gradient( 125.09deg,#474747 0%,rgba(255,255,255,0) 64.55% );border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:72px;height:80px;", ""], p => p.pageTheme === src.PARTNER.MMT ? `
     background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);
    ` : p.pageTheme === src.PARTNER.GI ? `background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);` : `
    `);
const SecureTravContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravContent",
  componentId: "sc-19r9m5r-3"
})(["align-self:center;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SecureTravOffer/SecureTravOffer.tsx








const SecureTravOffer = ({
  data
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravOfferStyle, {
    "data-test-id": "SecureTravOffer-SecureTravOfferStyle",
    children: data && data.map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravItem, {
        "data-test-id": `SecureTravOffer-SecureTravItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravImgWrap, {
          pageTheme: context ? context : undefined,
          "data-test-id": "SecureTravOffer-SecureTravImgWrap",
          children: item.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "48px",
            height: "48px",
            src: item.travImg,
            loading: "eager",
            "data-test-id": "SecureTravOffer-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravContent, {
          "data-test-id": "SecureTravOffer-SecureTravContent",
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-H5Tag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: "md",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }), item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            margin: device == "lg" ? "16px 0 0" : "8px 0 0",
            fontSize: device == "lg" ? "sm" : "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.info,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ const SecureTravOffer_SecureTravOffer = (SecureTravOffer);
// EXTERNAL MODULE: ../../node_modules/react-virtualized/dist/es/index.js + 34 modules
var es = __webpack_require__(37863);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModal.style.ts




const SelectCountryModalStyle = (0,styled_components_browser_esm/* default */.ZP)(components/* CommonModalDwebStyle */.E5).withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryModalStyle",
  componentId: "sc-1n427kc-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
const CountryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountryItem",
  componentId: "sc-1n427kc-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;margin:", ";cursor:", ";", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], props => props.margin && `${props.margin}`, props => props.disableCursor ? "default" : "pointer", components/* LandingButtonStyle */.zm, components/* CheckButtonStyle */.mT, Global/* theme.yellowText3 */.rS.yellowText3, components/* ToolTipCompWrapper */.V6);
const BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__BtnWrap",
  componentId: "sc-1n427kc-2"
})(["position:", ";", ";", ";width:100%;"], props => props.position ? `${props.position}` : `sticky`, props => props.bottom && `bottom:${props.bottom}`, props => props.background && `background:${props.background}`);
const CountrySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySection",
  componentId: "sc-1n427kc-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
const CountrySectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySectionWrap",
  componentId: "sc-1n427kc-4"
})(["@media ", "{padding:16px;}"], src.deviceType.mobile);
const PopularRegionCountries = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__PopularRegionCountries",
  componentId: "sc-1n427kc-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
const SelectCountrySheetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountrySheetStyle",
  componentId: "sc-1n427kc-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], components/* TMInputWrap */.dd);
const SelectCountryHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryHeader",
  componentId: "sc-1n427kc-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryCodeModal.tsx









const SelectCountryCodeModal = ({
  countryData,
  handleSelectCountry,
  handleClose
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const windowWidth = window.innerWidth - 60;
  const {
    0: countriesData,
    1: setCountriesData
  } = (0,react.useState)(countryData);
  const {
    0: searchTxt,
    1: setInputValue
  } = (0,react.useState)("");
  const rowHeight = 60;

  const calculateListHeight = () => {
    const rowCount = countriesData?.length ?? 0; // Replace with your actual data length

    const height = rowCount * rowHeight;
    return height;
  };

  const countryHandler = id => {
    if (id) {
      setCountriesData(countryData?.map(item => {
        if (id === item.id) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }

        return item;
      }));
    }
  };

  (0,react.useEffect)(() => {
    if (searchTxt?.length) {
      const filteredDataList = searchTxt ? countryData?.filter(items => items.countryName?.toLowerCase().includes(searchTxt.toLowerCase())) : countryData;
      setCountriesData(filteredDataList);
    }
  }, [searchTxt]);

  const rowRenderer = ({
    index,
    key
  }) => {
    const item = countriesData && countriesData[index];

    if (!item) {
      return null; // Return null if item is undefined
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-test-id": `SelectCountryCodeModal-rowRenderer-${key}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CountryItem, {
        onClick: () => countryHandler(item.id),
        "data-test-id": "SelectCountryCodeModal-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RadioButton */.EU, {
          handleChange: () => countryHandler(item.id),
          activeBtn: item.isSelected,
          "data-test-id": "SelectCountryCodeModal-rowRenderer-RadioButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
              alignItems: "center",
              gap: "8px",
              "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
              children: [item.countryFlag && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                src: item.countryFlag,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                fontSize: "sm",
                color: Global/* theme.blackText */.rS.blackText,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
                children: item.countryName
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
              fontWeight: "bold",
              fontSize: "xs",
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
              children: item.countryCode
            })]
          })
        })
      })
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* CommonModalDweb */.Eq, {
    handleClick: handleClose,
    customTitle: "Select Country",
    "data-test-id": "SelectCountryCodeModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TMFloatingInput */.Wz, {
      handleChange: e => setInputValue(e.target.value),
      inputValue: searchTxt,
      labelTxt: "Search Country Name",
      "data-test-id": "SelectCountryCodeModal-TMFloatingInput"
    }), countriesData?.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(CountrySection, {
      "data-test-id": "SelectCountryCodeModal-CountrySection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Country Name"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Code"
      })]
    }), countriesData && countriesData?.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(es/* List */.aV, {
      width: device === "lg" ? 360 : windowWidth,
      height: calculateListHeight(),
      style: {
        minHeight: calculateListHeight()
      },
      autoHeight: true,
      rowHeight: rowHeight,
      rowCount: countriesData.length,
      rowRenderer: rowRenderer,
      "data-test-id": "SelectCountryCodeModal-List"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      fontSize: "sm",
      color: Global/* theme.greyText */.rS.greyText,
      margin: "16px 0 16px",
      "data-test-id": "SelectCountryCodeModal-ParaTag",
      children: "No Country Found! Please enter correct name"
    }), countriesData?.length != 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
      "data-test-id": "SelectCountryCodeModal-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
        customWidth: "100%",
        customTitle: "Select",
        onClick: () => handleSelectCountry(countriesData),
        "data-test-id": "SelectCountryCodeModal-LandingButton"
      })
    })]
  });
};

/* harmony default export */ const SelectCountryModal_SelectCountryCodeModal = (SelectCountryCodeModal);
// EXTERNAL MODULE: ../../node_modules/fuse.js/dist/fuse.mjs
var fuse = __webpack_require__(89325);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var insurance_utils = __webpack_require__(62663);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionCountryModal.style.tsx



const modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalDwebStyle",
  componentId: "n7dugx-0"
})(["position:fixed;width:", ";height:", ";max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], p => p.customWidth ? p.customWidth : "420px", p => p.customHeight ? p.customHeight : "420px", components/* SectionDividersStyle */.$f, components/* TMInputWrap */.dd, src.deviceType.mobile, modalAnim, components/* TMInputWrap */.dd);
const CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalHeader",
  componentId: "n7dugx-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:85%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], components/* H5TagStyle */.Wl, p => p.nonClipHeading && `
     ${components/* H5TagStyle */.Wl} {
        white-space: unset;
        overflow: auto;
        width: 100%;
        span {
            overflow: auto;
            white-space: unset;
            max-width: 100%;
        }
    }
    `, src.deviceType.mobile);
const CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CrossIconWrap",
  componentId: "n7dugx-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionCountryModal.tsx







const RegionCountryModal = ({
  children,
  customTitle,
  customSubTitle,
  handleClick,
  customWidth,
  customIcon,
  errorModal,
  customHeight,
  nonClipHeading
}) => {
  (0,react.useEffect)(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return () => {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
    return () => {};
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ReactPortalComp */.hK, {
    "data-test-id": "RegionCountryModal-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customHeight: customHeight,
      customWidth: customWidth,
      "data-test-id": "RegionCountryModal-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionCountryModal-CommonModalHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            color: errorModal ? Global/* theme.redText */.rS.redText : Global/* theme.blackText */.rS.blackText,
            "data-test-id": "RegionCountryModal-H5Tag",
            children: [customIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "40px",
              height: "40px",
              src: customIcon,
              "data-test-id": "RegionCountryModal-ImageComponent"
            }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: customTitle,
              "data-test-id": "RegionCountryModal-FormattedText"
            })]
          }), customSubTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: customSubTitle,
            "data-test-id": "RegionCountryModal-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
          onClick: handleClick,
          "data-test-id": "RegionCountryModal-CrossIconWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "RegionCountryModal-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* BackDropComp */.YP, {
      onClose: handleClick,
      "data-test-id": "RegionCountryModal-BackDropComp"
    })]
  });
};

/* harmony default export */ const RegionModalDweb_RegionCountryModal = (RegionCountryModal);
// EXTERNAL MODULE: ../../node_modules/react-window/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__(88475);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/CountryList.style.tsx

const CountryList_style_ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CountryListstyle__ArrowButtonWrap",
  componentId: "jzswvv-0"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
const DescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__DescriptionWrap",
  componentId: "jzswvv-1"
})(["cursor:none;margin:10px 0px 0px 32px;border-radius:4px;padding:10px 6px 10px 10px;background-color:#f6f6f6;cursor:", ";"], props => props.isCursorPointer ? "pointer" : "default");
const ColumnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__ColumnWrapper",
  componentId: "jzswvv-2"
})(["display:flex;flex-direction:column;& > span{margin-bottom:-6px;}"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/CountryList.tsx










const CountryList = ({
  countryData,
  countryHandler,
  isCheckedHandler,
  setCountryData,
  searchQueryHighlighter,
  setIsSelectedError,
  showHeader,
  setCountrySelectToastMsg
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const windowWidth = window.innerWidth - 60; //TODO: handle default cell height using css var

  const defaultCellHeight = 57; //TODO: Check alternate height calculation using DOM elements

  const windowHeight = window.innerHeight - 213;
  const listRef = (0,react.useRef)(null);
  const {
    0: showViewAllButton,
    1: setShowViewAllButton
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const temp = countryData.map(data => {
      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  }, []);
  (0,react.useEffect)(() => {
    listRef?.current?.resetAfterIndex(0);
  }, [countryData]);

  const handleDescription = code => {
    const data = countryData.filter(data => data?.code === code)[0];

    if (data.showExpandedDescription || data.description.length < 80) {
      setShowViewAllButton(false);
      console.log(data.description.length);
      return data.description;
    }

    setShowViewAllButton(true);
    const tempDescData = data.description.substring(0, 80).split(" ");
    tempDescData.pop();
    const descData = tempDescData.join(" ") + "...";
    return descData;
  };

  const handleRegionDescription = code => {
    let temp = countryData.map(data => {
      if (data.code === code && !data.showDescription) {
        data["showDescription"] = true;
        data["showExpandedDescription"] = false;
        return data;
      }

      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  };

  const handleErrorToast = (0,insurance_utils/* debounce */.Ds)(() => {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  const handleCountrySelectError = country => {
    const isExclusiveCountrySelected = countryData.find(item => item.isExclusiveSelection && item.isSelected);

    if (isExclusiveCountrySelected && !country?.isExclusiveSelection && country.isDisabled) {
      setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
      handleErrorToast();
    } else if (country?.isExclusiveSelection && !isExclusiveCountrySelected && country.isDisabled) {
      setCountrySelectToastMsg("India cannot be chosen for International Travel");
      handleErrorToast();
    } else if (country.isDisabled) {
      setIsSelectedError(true);
      handleErrorToast();
    } else {
      {
        !country.isSelected && !country.showDescription && handleRegionDescription(country.code);
      }
      {
        country.isSelected && country.showDescription && handleRegionDescription(country.code);
      }
      countryHandler(country.code);
    }
  };

  const handleViewAll = code => {
    let temp = countryData.map(data => {
      if (data.code === code) {
        data["showExpandedDescription"] = !data["showExpandedDescription"];
      }

      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  };

  const rowRenderer = ({
    index,
    key
  }) => {
    const item = countryData?.[index];

    if (!item) {
      return null; // Return null if item is undefined
    } else if (item.type === "HEADER") {
      return showHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryItem, {
        disableCursor: true,
        margin: device === "lg" ? "0px 17px 0px 0px" : "",
        "data-test-id": "CountryList-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: item.name,
          baseStyle: {
            fontWeight: "bold",
            fontSize: "14px"
          },
          "data-test-id": "CountryList-rowRenderer-FormattedText"
        })
      });
    } else if (item.code) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-test-id": `CountryList-rowRenderer-${key}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CountryItem, {
          disableCursor: true,
          margin: device === "lg" ? "0px 17px 0px 0px" : "",
          "data-test-id": "CountryList-rowRenderer-CountryItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
            "data-test-id": "CountryList-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* CheckButton */.nt, {
              handleChange: () => handleCountrySelectError(item),
              isChecked: item.isDisabled ? true : isCheckedHandler(item),
              isDisabled: item.isDisabled,
              "data-test-id": "CountryList-rowRenderer-CheckButton",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
                handleClick: () => handleCountrySelectError(item),
                alignItems: "center",
                justifyContent: "space-between",
                "data-test-id": "CountryList-rowRenderer-FlexComp",
                children: [item.subtitle ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ColumnWrapper, {
                  "data-test-id": "CountryList-rowRenderer-ColumnWrapper",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: searchQueryHighlighter(item.name)
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                      value: item.subtitle,
                      baseStyle: {
                        fontSize: "12px",
                        fontWeight: "400"
                      },
                      "data-test-id": "CountryList-rowRenderer-FormattedText"
                    })
                  })]
                }) : searchQueryHighlighter(item.name), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item.countryCount,
                  baseStyle: {
                    padding: "0px 10px 0px 0px",
                    fontSize: "12px",
                    color: "#4A4A4A"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item.regionName,
                  baseStyle: {
                    fontSize: "12px",
                    color: "#0000004D"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                })]
              })
            }), item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryList_style_ArrowButtonWrap, {
              onClick: () => {
                handleRegionDescription(item.code);
              },
              "data-test-id": "CountryList-rowRenderer-ArrowButtonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                width: "9px",
                height: "9px",
                margin: "0px 0px 0px 0px",
                src: item.showDescription ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                "data-test-id": "CountryList-rowRenderer-ImageComponent"
              })
            })]
          }), item.showDescription && item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionWrap, {
            "data-test-id": "CountryList-rowRenderer-DescriptionWrap",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: item.descTitle,
              baseStyle: {
                fontWeight: "bold",
                fontSize: "14px"
              },
              "data-test-id": "CountryList-rowRenderer-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: handleDescription(item.code),
                baseStyle: {
                  fontSize: "14px"
                },
                "data-test-id": "CountryList-rowRenderer-FormattedText"
              })
            }), showViewAllButton && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
              handleClick: () => {
                handleViewAll(item.code);
              },
              fontWeight: "bold",
              "data-test-id": "CountryList-rowRenderer-AnchorTag",
              children: "View All"
            })]
          })]
        })
      }, key);
    }

    return;
  };

  const getItemSize = (code, isShowDesc, isShowAllDesc) => {
    let expansionValue = 0;

    if (isShowAllDesc) {
      expansionValue = 2;
    } else if (isShowDesc) {
      expansionValue = 1;
    }

    return (0,insurance_utils/* interpolateRowHeight */.IS)(device === "lg" ? 360 : windowWidth, code, expansionValue) || defaultCellHeight;
  };

  const getItemSizes = index => {
    const height = countryData[index].type === "REGION" ? getItemSize(countryData[index].code, countryData[index].showDescription, countryData[index].showExpandedDescription) : defaultCellHeight;
    return height;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* VariableSizeList */.S_, {
    height: device === "lg" ? 380 : windowHeight,
    itemCount: countryData.length,
    itemSize: getItemSizes,
    width: device === "lg" ? 360 : windowWidth,
    ref: listRef,
    "data-test-id": "CountryList-FixList",
    children: ({
      index,
      style
    }) => {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: style,
        "data-test-id": `CountryList-${index}`,
        children: rowRenderer({
          index,
          key: index
        })
      }, index);
    }
  });
};

/* harmony default export */ const SelectCountryModal_CountryList = (CountryList);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModal.tsx


function SelectCountryModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountryModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountryModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountryModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const SelectCountryModal_analytics = (0,insurance/* getAnalytics */.I)();
const DEBOUNCE_TIME = 300;

const fuzzySearch = (searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) => {
  const selectedCountriesData = displayCountryData.filter(country => country.isSelected && !country.isDisabled);
  const searchResults = searcher.search(searchValue);
  const filteredData = searchResults?.map(match => match?.item);
  const originalSortData = countryData.map(country => {
    return displayCountryData.find(item => item.code === country.code);
  });
  const allObjects = [...selectedCountriesData, ...filteredData, ...originalSortData];
  const tempObj = allObjects.reduce((acc, obj) => {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  const uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

const debouncedSearch = (0,insurance_utils/* debounce */.Ds)(fuzzySearch, DEBOUNCE_TIME);

const SelectCountryModal = ({
  handleSelectCountry,
  countryData,
  setShowCountry,
  showCountry,
  setCountryData,
  countrySelectErrMsg,
  setIsCountryError,
  popularCountries,
  setPopularCountries,
  customSubTitle,
  handleDescriptionModal
}) => {
  const {
    0: displayCountryData,
    1: setDisplayCountrysData
  } = (0,react.useState)(countryData);
  const {
    0: searchTxt,
    1: setSearchTxt
  } = (0,react.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react.useState)("");
  const searchedCountriesOmn = (0,react.useRef)([]);
  const selectedCountriesOmn = (0,react.useRef)([]);
  const searcher = new fuse/* default */.Z(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  const noSearchResults = addTimeOut => {
    let allObjects = [];
    const selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    const selectedCountriesData = displayCountryData.filter(country => {
      return country.isSelected && !country.isDisabled;
    });
    const originalSortData = countryData.map(country => {
      return displayCountryData.find(item => item.code === country.code);
    });

    if (selectedCountriesData.length) {
      allObjects = [SelectCountryModal_objectSpread({}, selectedHeader), ...selectedCountriesData, ...originalSortData];
      const tempObj = allObjects.reduce((acc, obj) => {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      const uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(uniqueObjects);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(originalSortData);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react.useEffect)(() => {
    noSearchResults(false);
  }, []);

  const countryClickHandler = code => {
    handleDescriptionModal(displayCountryData.filter(data => data.code === code)[0]);
    let updatedCountryArr = displayCountryData?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return SelectCountryModal_objectSpread({}, country);
        }
        /* istanbul ignore next */


        if (selectedCountriesOmn?.current?.length >= 30) {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current?.slice(1), country.code];
        } else {
          selectedCountriesOmn.current = [...selectedCountriesOmn.current, country.code];
        }

        return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const isExclusiveCountrySelected = updatedCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    updatedCountryArr = updatedCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? SelectCountryModal_objectSpread({}, country) : SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
          isDisabled: true
        }) : SelectCountryModal_objectSpread({}, country);
      }

      return SelectCountryModal_objectSpread({}, country);
    });
    const selectedCountryCodes = updatedCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedCountryCodes.map(item => {
      updatedCountryArr = updatedCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return SelectCountryModal_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    const popularCountryData = updatedCountryArr.filter(country => country.isSelected || country.isPopular);
    setPopularCountries([...popularCountryData.filter(country => country.isSelected && !country.isDisabled), ...popularCountryData.filter(country => country.isDisabled), ...popularCountryData.filter(country => !country.isSelected && !country.isDisabled)]);
  };

  const handleSearchtxt = (0,react.useCallback)(searchValue => {
    debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  const onSearchChange = searchValue => {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  const searchQueryHighlighter = ele => {
    const withSpecialCharsSupport = searchTxt?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const searchRegex = new RegExp(`(${withSpecialCharsSupport})`, "ig");
    const highlighted = ele.replace(searchRegex, match => `<span class="highlight">${match}</span>`);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModal-searchQueryHighlighter-ParaTag"
    });
  };

  const isCheckedHandler = (0,react.useCallback)(data => {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  const handleCrossClick = () => {
    setPopularCountries(showCountry);

    if (searchedCountriesOmn?.current?.length) {
      SelectCountryModal_analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    let tempCountryData = displayCountryData.map(country => {
      return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(data => {
      tempCountryData = tempCountryData.map(country => {
        if (data.code === country.code) {
          return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModal_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(SelectCountryModal_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  const onCountrySubmit = () => {
    setIsCountryError(false);

    if (searchedCountriesOmn?.current?.length) {
      SelectCountryModal_analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn?.current?.length) {
      SelectCountryModal_analytics?.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn?.current?.join("|")
      } //"click"
      );
      selectedCountriesOmn.current = [];
    }

    let countryDataArr = countryData.map(country => {
      return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(data => {
      countryDataArr = countryDataArr.map(country => {
        if (country.code === data.code) {
          return SelectCountryModal_objectSpread(SelectCountryModal_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModal_objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    const selectedCountryCodes = displayCountryData.filter(item => item.isSelected && !item.isDisabled).map(item => item.code);
    (0,insurance_utils/* replaceHistoryRemoveParams */._A)("countries");
    (0,insurance_utils/* replaceHistory */.df)("countries", selectedCountryCodes.join(","));
    const selectedNonPopCountries = displayCountryData.filter(data => data.isSelected && !data.isPopular);
    SelectCountryModal_analytics?.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(c => c.name).join("|")
    } //"click"
    );
    handleSelectCountry && handleSelectCountry();
  };

  const handleSearchTxt = event => {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      if (searchedCountriesOmn?.current?.length >= 30) {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current?.slice(1), searchTxt];
      } else {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current, searchTxt];
      }
    }

    setSearchTxt(_ => event.target.value);
    onSearchChange(event.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RegionModalDweb_RegionCountryModal, {
    customHeight: "600px",
    handleClick: onCountrySubmit,
    customTitle: "Select Destinations",
    customSubTitle: customSubTitle,
    "data-test-id": "SelectCountryModal-RegionCountryModal",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TMFloatingInput */.Wz, {
      handleChange: e => handleSearchTxt(e),
      inputValue: searchTxt,
      labelTxt: "Search Country/Region",
      "data-test-id": "SelectCountryModal-TMFloatingInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CountrySectionWrap, {
      "data-test-id": "SelectCountryModal-CountrySectionWrap",
      children: displayCountryData?.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_CountryList, {
        countryData: searchTxt.length ? displayCountryData.filter(country => country.type !== "HEADER") : displayCountryData,
        countryHandler: countryClickHandler,
        isCheckedHandler: isCheckedHandler,
        searchQueryHighlighter: searchQueryHighlighter,
        setCountryData: setDisplayCountrysData,
        setIsSelectedError: setIsSelectedError,
        showHeader: !searchTxt.length,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        "data-test-id": "SelectCountryModal-CountryList"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        fontSize: "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "30px 0px 0px 0px",
        "data-test-id": "SelectCountryModal-ParaTag",
        children: "No Country Found! Please enter correct name"
      })
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
      toastTxt: countrySelectToastMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModal-WebToast"
    }), displayCountryData?.length && /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
      "data-test-id": "SelectCountryModal-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
        margin: "16px 0px 0px 0px",
        customWidth: "100%",
        customTitle: "Add Destination",
        onClick: onCountrySubmit,
        "data-test-id": "SelectCountryModal-LandingButton"
      })
    })]
  });
};

/* harmony default export */ const SelectCountryModal_SelectCountryModal = (SelectCountryModal);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SelectCountryModal/SelectCountryModalSheet.tsx


function SelectCountryModalSheet_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountryModalSheet_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountryModalSheet_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountryModalSheet_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











const SelectCountryModalSheet_analytics = (0,insurance/* getAnalytics */.I)();
const SelectCountryModalSheet_DEBOUNCE_TIME = 300;

const SelectCountryModalSheet_fuzzySearch = (searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) => {
  const selectedCountriesData = displayCountryData.filter(country => country.isSelected && !country.isDisabled);
  const searchResults = searcher.search(searchValue);
  const filteredData = searchResults?.map(match => match?.item);
  const originalSortData = countryData.map(country => {
    return displayCountryData.find(item => item.code === country.code);
  });
  const allObjects = [...selectedCountriesData, ...filteredData, ...originalSortData];
  const tempObj = allObjects.reduce((acc, obj) => {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  const uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

const SelectCountryModalSheet_debouncedSearch = (0,insurance_utils/* debounce */.Ds)(SelectCountryModalSheet_fuzzySearch, 300);

const SelectCountryModalSheet = ({
  handleSelectCountry,
  countryData,
  setShowCountry,
  setCountryData,
  showCountry,
  countrySelectErrMsg,
  setIsCountryError,
  popularCountries,
  setPopularCountries,
  handleDescriptionModal,
  customSubTitle
}) => {
  const {
    0: displayCountryData,
    1: setDisplayCountrysData
  } = (0,react.useState)(countryData);
  const {
    0: searchTxt,
    1: setSearchTxt
  } = (0,react.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const searchedCountriesOmn = (0,react.useRef)([]);
  const selectedCountriesOmn = (0,react.useRef)([]);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react.useState)("");
  const searcher = new fuse/* default */.Z(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  const noSearchResults = addTimeOut => {
    let allObjects = [];
    const selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    const selectedCountriesData = displayCountryData.filter(country => {
      return country.isSelected && !country.isDisabled;
    });
    const originalSortData = countryData.map(country => {
      return displayCountryData.find(item => item.code === country.code);
    });

    if (selectedCountriesData.length) {
      allObjects = [SelectCountryModalSheet_objectSpread({}, selectedHeader), ...selectedCountriesData, ...originalSortData];
      const tempObj = allObjects.reduce((acc, obj) => {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      const uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(uniqueObjects);
      }, SelectCountryModalSheet_DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(originalSortData);
      }, SelectCountryModalSheet_DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react.useEffect)(() => {
    noSearchResults(false);
  }, []);

  const countryClickHandler = code => {
    handleDescriptionModal(displayCountryData.filter(data => data.code === code)[0]);
    let updatedCountryArr = displayCountryData?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return SelectCountryModalSheet_objectSpread({}, country);
        }
        /* istanbul ignore next */


        if (selectedCountriesOmn?.current?.length >= 30) {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current?.slice(1), country.code];
        } else {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current, country.code];
        }

        return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const isExclusiveCountrySelected = updatedCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    updatedCountryArr = updatedCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? SelectCountryModalSheet_objectSpread({}, country) : SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
          isDisabled: true
        }) : SelectCountryModalSheet_objectSpread({}, country);
      }

      return SelectCountryModalSheet_objectSpread({}, country);
    });
    const selectedCountryCodes = updatedCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedCountryCodes.map(item => {
      updatedCountryArr = updatedCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return SelectCountryModalSheet_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    const popularCountryData = updatedCountryArr.filter(country => country.isSelected || country.isPopular);
    setPopularCountries([...popularCountryData.filter(country => country.isSelected && !country.isDisabled), ...popularCountryData.filter(country => country.isDisabled), ...popularCountryData.filter(country => !country.isSelected && !country.isDisabled)]);
  };

  const handleSearchtxt = (0,react.useCallback)(searchValue => {
    SelectCountryModalSheet_debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  const onSearchChange = searchValue => {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  const searchQueryHighlighter = ele => {
    const withSpecialCharsSupport = searchTxt?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const searchRegex = new RegExp(`(${withSpecialCharsSupport})`, "ig");
    const highlighted = ele.replace(searchRegex, match => `<span class="highlight">${match}</span>`);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModalSheet-searchQueryHighlighter-ParaTag"
    });
  };

  const isCheckedHandler = (0,react.useCallback)(data => {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  const handleCrossClick = () => {
    setPopularCountries(showCountry);

    if (searchedCountriesOmn?.current?.length) {
      SelectCountryModalSheet_analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    let tempCountryData = displayCountryData.map(country => {
      return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(data => {
      tempCountryData = tempCountryData.map(country => {
        if (data.code === country.code) {
          return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalSheet_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(SelectCountryModalSheet_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  const onCountrySubmit = () => {
    setIsCountryError(false);

    if (searchedCountriesOmn?.current?.length) {
      SelectCountryModalSheet_analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      } //"click"
      );
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn?.current?.length) {
      SelectCountryModalSheet_analytics?.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn?.current?.join("|")
      } //"click"
      );
      selectedCountriesOmn.current = [];
    }

    let countryDataArr = countryData.map(country => {
      return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(data => {
      countryDataArr = countryDataArr.map(country => {
        if (country.code === data.code) {
          return SelectCountryModalSheet_objectSpread(SelectCountryModalSheet_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalSheet_objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    const selectedCountryCodes = displayCountryData.filter(item => item.isSelected && !item.isDisabled).map(item => item.code);
    (0,insurance_utils/* replaceHistoryRemoveParams */._A)("countries");
    (0,insurance_utils/* replaceHistory */.df)("countries", selectedCountryCodes.join(","));
    const selectedNonPopCountries = displayCountryData.filter(data => data.isSelected && !data.isPopular);
    SelectCountryModalSheet_analytics?.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(c => c.name).join("|")
    } //"click"
    );
    handleSelectCountry && handleSelectCountry();
  };

  const handleSearchTxt = event => {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      if (searchedCountriesOmn?.current?.length >= 30) {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current?.slice(1), searchTxt];
      } else {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current, searchTxt];
      }
    }

    setSearchTxt(_ => event.target.value);
    onSearchChange(event.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ReactPortalComp */.hK, {
    "data-test-id": "SelectCountryModalSheet-ReactPortalComp",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountrySheetStyle, {
      "data-test-id": "SelectCountryModalSheet-SelectCountrySheetStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountryHeader, {
        "data-test-id": "SelectCountryModalSheet-SelectCountryHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
          handleClick: handleCrossClick,
          "data-test-id": "SelectCountryModalSheet-AnchorTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
              fill: "#808080"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
          flexDirection: "column",
          "data-test-id": "SelectCountryModalSheet-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: "md",
            fontWeight: "bold",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SelectCountryModalSheet-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: "Select Destinations",
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
            fontSize: "xs",
            color: Global/* theme.greyText6 */.rS.greyText6,
            "data-test-id": "SelectCountryModalSheet-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: customSubTitle,
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TMFloatingInput */.Wz, {
        handleChange: e => handleSearchTxt(e),
        inputValue: searchTxt,
        labelTxt: "Search Country/Region",
        "data-test-id": "SelectCountryModalSheet-TMFloatingInput"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CountrySectionWrap, {
        "data-test-id": "SelectCountryModalSheet-CountrySectionWrap",
        children: displayCountryData?.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_CountryList, {
          countryData: searchTxt.length ? displayCountryData.filter(country => country.type !== "HEADER") : displayCountryData,
          countryHandler: countryClickHandler,
          isCheckedHandler: isCheckedHandler,
          searchQueryHighlighter: searchQueryHighlighter,
          setCountryData: setDisplayCountrysData,
          setIsSelectedError: setIsSelectedError,
          showHeader: !searchTxt.length,
          setCountrySelectToastMsg: setCountrySelectToastMsg,
          "data-test-id": "SelectCountryModalSheet-CountryList"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
          fontSize: "sm",
          color: Global/* theme.greyText */.rS.greyText,
          margin: "30px 0px 0px 0px",
          "data-test-id": "SelectCountryModalSheet-ParaTag",
          children: "No Country Found! Please enter correct name"
        })
      }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "75px",
        "data-test-id": "SelectCountryModalSheet-WebToast"
      }), displayCountryData?.length && /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
        position: "fixed",
        bottom: "0px",
        background: "white",
        "data-test-id": "SelectCountryModalSheet-BtnWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
          margin: "12px 16px 12px 16px",
          customWidth: "92%",
          customTitle: "Add Destination",
          onClick: onCountrySubmit,
          "data-test-id": "SelectCountryModalSheet-LandingButton"
        })
      })]
    })
  });
};

/* harmony default export */ const SelectCountryModal_SelectCountryModalSheet = (SelectCountryModalSheet);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SeoContent/SeoContent.style.ts



const SeoContentStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "SeoContentstyle__SeoContentStyle",
  componentId: "sc-1ipkwsi-0"
})(["background:#fff;width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}ul{list-style:initial;padding-left:30px;}h1,h2,h3,h4,h5,h6,p,ul{margin:1em 0;}@media ", "{padding:0 16px;", "}"], p => p.pageTheme === src.PARTNER.GI && `
    background: #EFF3F8;
    padding-bottom:80px;
    `, components/* H2TagStyle */.FI, src.deviceType.mobile, src.deviceType.mobile, p => p.pageTheme === src.PARTNER.GI && `
    background: #fff;
    padding-top:16px;
    `);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/SeoContent/SeoContent.tsx





const SeoContent = ({
  seoContent
}) => {
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SeoContentStyle, {
    pageTheme: context ? context : undefined,
    "data-test-id": "SeoContent-SeoContentStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui_widgets_src/* InnerContentWrap */.IY, {
      dangerouslySetInnerHTML: {
        __html: seoContent
      },
      "data-test-id": "SeoContent-InnerContentWrap"
    })
  });
};

/* harmony default export */ const SeoContent_SeoContent = (SeoContent);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionModalDweb.style.tsx



const RegionModalDweb_style_modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const RegionModalDweb_style_CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalDwebStyle",
  componentId: "sc-1g04rko-0"
})(["position:fixed;width:", ";height:fit-content;max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], p => p.customWidth ? p.customWidth : "420px", components/* SectionDividersStyle */.$f, components/* TMInputWrap */.dd, src.deviceType.mobile, RegionModalDweb_style_modalAnim, components/* TMInputWrap */.dd);
const RegionModalDweb_style_CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalHeader",
  componentId: "sc-1g04rko-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;gap:10px;white-space:nowrap;overflow:hidden;align-items:center;justify-content:space-between;text-overflow:ellipsis;width:100%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], components/* H5TagStyle */.Wl, p => p.nonClipHeading && `
     ${components/* H5TagStyle */.Wl} {
        white-space: unset;
        overflow: auto;
        width: 100%;
        span {
            overflow: auto;
            white-space: unset;
            max-width: 100%;
        }
    }
    `, src.deviceType.mobile);
const RegionModalDweb_style_CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CrossIconWrap",
  componentId: "sc-1g04rko-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/RegionModalDweb/RegionModalDweb.tsx






const RegionModalDweb = ({
  children,
  customTitle,
  handleClick,
  customWidth,
  nonClipHeading
}) => {
  (0,react.useEffect)(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return () => {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(() => {
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ReactPortalComp */.hK, {
    "data-test-id": "RegionModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(RegionModalDweb_style_CommonModalDwebStyle, {
      customWidth: customWidth,
      "data-test-id": "RegionModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_style_CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionModalDweb-CommonModalHeader",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            "data-test-id": "RegionModalDweb-H5Tag",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: "28px",
              height: "28px",
              src: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_47_6c7992dd19.svg",
              "data-test-id": "RegionModalDweb-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_style_CrossIconWrap, {
              onClick: handleClick,
              "data-test-id": "RegionModalDweb-CrossIconWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                width: "28px",
                height: "28px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
                "data-test-id": "RegionModalDweb-ImageComponent"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: "xlarge",
            fontWeight: "black",
            "data-test-id": "RegionModalDweb-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: customTitle,
              "data-test-id": "RegionModalDweb-FormattedText"
            })
          })]
        })
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* BackDropComp */.YP, {
      onClose: handleClick,
      "data-test-id": "RegionModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ const RegionModalDweb_RegionModalDweb = (RegionModalDweb);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DescriptionModal/DescriptionModal.style.tsx

const PopularDescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DescriptionModalstyle__PopularDescriptionWrap",
  componentId: "sc-217pnf-0"
})(["border-radius:4px;padding:12px;background-color:#f6f6f6;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/DescriptionModal/DescriptionModal.tsx







const DescriptionModal = ({
  handleDescriptionModal,
  value,
  title
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_RegionModalDweb, {
    handleClick: handleDescriptionModal,
    customTitle: title,
    "data-test-id": "DescriptionModal-RegionModalDweb",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PopularDescriptionWrap, {
      "data-test-id": "DescriptionModal-PopularDescriptionWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: "Countries Covered: ",
        baseStyle: {
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "xs"
        },
        "data-test-id": "DescriptionModal-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: value,
        "data-test-id": "DescriptionModal-FormattedText"
      })]
    })
  });
};

/* harmony default export */ const DescriptionModal_DescriptionModal = (DescriptionModal);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravelDetails.style.ts
var TravelDetails_style = __webpack_require__(84333);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/PopularCountryCompV2.tsx









const PopularCountryComp = ({
  popCountry,
  handleShowOtherCountry,
  otherCountryTxt,
  handlePopularCountrySelect,
  setIsSelectedError,
  setCountrySelectToastMsg
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const isCheckedHandler = (0,react.useCallback)(data => {
    return data?.isSelected;
  }, [popCountry]);
  const handleErrorToast = (0,insurance_utils/* debounce */.Ds)(() => {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  const handleCountrySelect = item => {
    if (item.isDisabled) {
      const isExclusiveCountrySelected = popCountry?.find(item => item.isExclusiveSelection && item.isSelected);

      if (isExclusiveCountrySelected && !item?.isExclusiveSelection && item.isDisabled) {
        setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
        handleErrorToast();
      } else if (item?.isExclusiveSelection && !isExclusiveCountrySelected && item.isDisabled) {
        setCountrySelectToastMsg("India cannot be chosen for International Travel");
        handleErrorToast();
      } else if (item.isDisabled) {
        setIsSelectedError(true);
        handleErrorToast();
      }
    } else {
      handlePopularCountrySelect(item.code);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* PopularCountry */.Nj, {
    "data-test-id": "PopularCountryComp-PopularCountry",
    children: [popCountry && popCountry.slice(0, 5).map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* PopularCountryItem */.QQ, {
        listSelected: isCheckedHandler(item),
        onClick: () => handleCountrySelect(item),
        "data-test-id": `PopularCountryComp-PopularCountryItem-${index}`,
        children: [index !== popCountry.length && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* CheckButton */.nt, {
          isDisabled: item.isDisabled,
          isChecked: item.isDisabled ? true : isCheckedHandler(item),
          "data-test-id": "PopularCountryComp-CheckButton",
          children: [!item.img && item.name && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* BgText */.P5, {
            "data-test-id": "PopularCountryComp-BgText",
            children: item?.code
          }), item.upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TripUpcoming */.TR, {
            "data-test-id": "PopularCountryComp-TripUpcoming",
            children: "TRIP UPCOMING"
          }), item?.name && !item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryNameTxt */.xZ, {
            title: item.name,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: item?.name
          }), item?.name && item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryNameTxt */.xZ, {
            title: item.name + item.subtitle,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: item?.name + " " + item.subtitle
          })]
        }), item?.img && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* CountryImg */.Q_, {
          "data-test-id": "PopularCountryComp-CountryImg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: device == "sm" ? "100%" : "80px",
            height: device == "lg" ? "80px" : "82px",
            src: item.img,
            loading: "eager",
            "data-test-id": "PopularCountryComp-ImageComponent"
          })
        })]
      }, index);
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* OtherCountyBtn */["in"], {
      onClick: handleShowOtherCountry,
      "data-test-id": "PopularCountryComp-OtherCountyBtn",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
        loading: "eager",
        "data-test-id": "PopularCountryComp-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.blueText */.rS.blueText,
        "data-test-id": "PopularCountryComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: otherCountryTxt,
          "data-test-id": "PopularCountryComp-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const PopularCountryCompV2 = (PopularCountryComp);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/UpcomingTrips.tsx










const UpcomingTrips_analytics = (0,insurance/* getAnalytics */.I)();

const UpcomingTrips = ({
  country,
  travelDuration,
  travellerNum,
  travellerTitle,
  handleUpcomingTripClick
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: isUpcomingTripSelected,
    1: setIsUpcomingTripSelected
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const isUpcomingTrip = queryParams.get("isUpcomingTrip");

    if (isUpcomingTrip) {
      setIsUpcomingTripSelected(true);
    }

    UpcomingTrips_analytics?.trackLandingEvents({
      actionType: "upcoming_trips_shown"
    });
  }, []);

  const showFormattedDate = date => {
    if (date) {
      const dateValue = (0,insurance_utils/* convertUnixToDate */.P9)(date);
      return (0,insurance_utils/* formatDate */.p6)(dateValue, src.DATE_FORMATS["DD MMM YY"]);
    }

    return "";
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* UpcomingTripStyle */.Vr, {
    selected: isUpcomingTripSelected,
    onClick: handleUpcomingTripClick,
    "data-test-id": "UpcomingTrips-UpcomingTripStyle",
    children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* UpcomingTripTag */.cM, {
      "data-test-id": "UpcomingTrips-UpcomingTripTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontSize: "xxs",
        color: Global/* theme.whiteText */.rS.whiteText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: "UPCOMING TRIP"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      flexDirection: "column",
      "data-test-id": "UpcomingTrips-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
        fontWeight: "bold",
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: country,
          "data-test-id": "UpcomingTrips-FormattedText"
        }), "\xA0"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
        fontSize: "xs",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [` ${showFormattedDate(travelDuration?.startDate)} - ${showFormattedDate(travelDuration?.endDate)}`, " ", "| ", travellerNum, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travellerTitle,
          "data-test-id": "UpcomingTrips-FormattedText"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
      "data-test-id": "UpcomingTrips-AnchorTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageTag */.Du, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
        width: "16px",
        height: "16px",
        "data-test-id": "UpcomingTrips-ImageTag"
      })
    })]
  });
};

/* harmony default export */ const TravelDetails_UpcomingTrips = (UpcomingTrips);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 1 modules
var utility_src = __webpack_require__(97427);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents.ts + 1 modules
var xdmEvents = __webpack_require__(46535);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingTo.tsx


function TravellingTo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TravellingTo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TravellingTo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TravellingTo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















const TravellingTo_analytics = (0,insurance/* getAnalytics */.I)();

const TravellingTo = ({
  travellingToSection,
  upcomingTrip,
  calendarDatesLimit,
  travelSearchBanner,
  btnDisabledState = true,
  nextPageRoute,
  countryCodes,
  setLoginModal
}) => {
  const buttonRef = (0,react.useRef)(null);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const context = (0,hooks/* usePartnerContext */.X)();
  const {
    otherCountryTxt,
    travelNote,
    travDateTitle,
    travCountTitle,
    travPurpTitle,
    travelPurposeTxt,
    popularCountryTxt,
    travelBtnTxt,
    travelSearchForm
  } = travellingToSection || {};
  const {
    label,
    error_message,
    countrySelectErrMsg,
    placeHolder,
    value
  } = travelSearchForm.regionCountryList;
  const {
    0: popularCountries,
    1: setPopularCountries
  } = (0,react.useState)([]);
  const {
    0: countryData,
    1: setCountryData
  } = (0,react.useState)([]);
  const {
    0: showOtherCountry,
    1: setOtherCountry
  } = (0,react.useState)(false);
  const {
    0: countValue,
    1: setCountValue
  } = (0,react.useState)(0);
  const {
    0: calenderValue,
    1: setCalenderValue
  } = (0,react.useState)();
  const {
    0: showCountry,
    1: setShowCountry
  } = (0,react.useState)([]);
  const {
    0: isCountryError,
    1: setIsCountryError
  } = (0,react.useState)(false);
  const {
    0: descriptionTxt,
    1: setDescriptionTxt
  } = (0,react.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: descTitle,
    1: setDescTitle
  } = (0,react.useState)("");
  const {
    0: segments,
    1: setSegments
  } = (0,react.useState)([]);
  const {
    0: segmentSelected,
    1: setSegmentSelected
  } = (0,react.useState)({});
  const {
    0: isSegmentModalShown,
    1: setIsSegmentModalShown
  } = (0,react.useState)(false);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react.useState)("");
  const {
    0: showLoginModal,
    1: setShowLoginModal
  } = (0,react.useState)(false);
  const {
    0: nextPageError,
    1: setNextPageError
  } = (0,react.useState)(); //set the default selected segement

  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam = queryParams.get("segment");
    const segments = travelSearchForm?.segments?.value;

    if (segments) {
      const segment = segments.find(item => item.id === segParam || !segParam && item.isSelected);

      if (segment) {
        setSegmentSelected(segment);
        (0,insurance_utils/* replaceHistory */.df)("segment", segment.id);
      }
    }
  }, []); //set the travelSerachForm.segments to segments

  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segParam = queryParams.get("segment");

    if (travelSearchForm?.segments?.value) {
      if (segParam) {
        handleSegementSelect(segParam);
      } else {
        setSegments(travelSearchForm?.segments?.value);
      }
    }
  }, [travelSearchForm?.segments]);
  (0,react.useEffect)(() => {
    if (travelSearchForm?.segments) {
      TravellingTo_analytics?.trackLandingEvents({
        actionType: "special_segments_shown"
      } //"click"
      );
      (0,XDMAnalytics.trackComponentView)({
        name: "special_segments_shown",
        type: "card"
      });
    }
  }, [travelSearchForm?.segments]);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const selectedCountries = queryParams.get("countries") || countryCodes;
    let selectedCountryCodes;

    if (selectedCountries) {
      selectedCountryCodes = selectedCountries?.split(",");
    } else if (upcomingTrip?.countryCode) {
      selectedCountryCodes = upcomingTrip?.countryCode;
      (0,insurance_utils/* replaceHistory */.df)("countries", upcomingTrip?.countryCode);
    }

    let totalCountryData = value?.map(data => {
      if (selectedCountryCodes?.includes(data.code)) {
        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return TravellingTo_objectSpread({}, data);
    });
    const isExclusiveCountrySelected = totalCountryData?.find(item => item.isExclusiveSelection && item.isSelected);
    totalCountryData = totalCountryData?.map(country => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread({}, country) : TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (totalCountryData.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      }

      return TravellingTo_objectSpread({}, country);
    });
    const selectedRegionCodes = totalCountryData?.filter(data => data.isSelected && data.type === "REGION")?.map(data => data.code);
    selectedRegionCodes?.map(code => {
      totalCountryData = totalCountryData?.map(country => {
        if (country.regionCodes && country.regionCodes.includes(code)) {
          return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return TravellingTo_objectSpread({}, country);
      });
    });
    setCountryData(totalCountryData);
    let popularCountryData = totalCountryData?.filter(country => country.isSelected || country.isPopular) ?? [];
    popularCountryData = [...popularCountryData?.filter(country => country.isSelected && !country.isDisabled), ...popularCountryData?.filter(country => country.isDisabled), ...popularCountryData.filter(country => !country.isSelected && !country.isDisabled)];
    setShowCountry([...popularCountryData]);
    setPopularCountries([...popularCountryData]);
  }, [value, upcomingTrip, travelSearchForm.segments]);
  (0,react.useEffect)(() => {
    const button = buttonRef.current;
    let viewportMargin = 16;
    let searchBarOffset = 60;

    if (button) {
      const rect = button.getBoundingClientRect();
      const offsetTop = window.scrollY + rect.top;
      const isInViewport = offsetTop >= 0 && offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        const scrollPosition = offsetTop - window.innerHeight + rect.height + viewportMargin + searchBarOffset;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth"
        });
      }
    }
  }, [showCountry]);

  const populateTravelDetails = (countryCodes, startDate, endDate, travellers) => {
    if (countryCodes) {
      (0,insurance_utils/* replaceHistory */.df)("countries", countryCodes);
    }

    if (startDate) {
      (0,insurance_utils/* replaceHistory */.df)("startDate", startDate);
    }

    if (endDate) {
      (0,insurance_utils/* replaceHistory */.df)("endDate", endDate);
    }

    if (travellers) {
      (0,insurance_utils/* replaceHistory */.df)("travellers", travellers);
    }
  };

  const handleUpcomingTripClick = () => {
    (0,insurance_utils/* replaceHistory */.df)("isUpcomingTrip", "true");
    (0,utility_src/* removeSessionStorageItem */.lD)(src.STORAGE_KEYS.TRAVELLER_DETAILS);
    TravellingTo_analytics?.trackLandingEvents({
      actionType: "upcoming_trips_clicked"
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upcoming_trips_clicked"
      }
    });
    const {
      countryCode,
      travelDuration,
      travellerNum
    } = upcomingTrip || {};
    const selectedCountry = countryData?.find(country => country.code === countryCode);
    populateTravelDetails(selectedCountry?.code, travelDuration?.startDate?.toString(), travelDuration?.endDate?.toString(), travellerNum?.toString());

    if (nextPageRoute) {
      navigation/* navigationActionsSeo.navigateToPageByRouteName */.Ro.navigateToPageByRouteName(`${nextPageRoute}&isUpcomingTrip=true`);
    } else {
      const data = {
        startDate: travelDuration?.startDate?.toString(),
        endDate: travelDuration?.endDate?.toString(),
        travellers: travellerNum?.toString?.(),
        countries: [countryCode],
        isUpcomingTrip: true
      };
      navigation/* navigationActionsSeo.navigateToListing */.Ro.navigateToListing(data);
    }
  };

  const handleShowOtherCountry = () => {
    if (!showOtherCountry) {
      let countryDataArr = countryData?.map(country => {
        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: false
        });
      });
      popularCountries.map(data => {
        countryDataArr = countryDataArr?.map(country => {
          if (country.code === data.code) {
            return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
              isSelected: data.isSelected
            });
          }

          return TravellingTo_objectSpread({}, country);
        });
      });
      const isExclusiveCountrySelected = countryDataArr.find(item => item.isExclusiveSelection && item.isSelected);
      countryDataArr = countryDataArr?.map(country => {
        if (isExclusiveCountrySelected) {
          return country.isExclusiveSelection ? TravellingTo_objectSpread({}, country) : TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isSelected: false,
            isDisabled: true
          });
        } else if (countryDataArr.some(item => item.isSelected)) {
          return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          }) : TravellingTo_objectSpread({}, country);
        }

        return TravellingTo_objectSpread({}, country);
      });
      const selectedRegionCodes = countryDataArr.filter(data => data.isSelected && data.type === "REGION").map(data => data.code);
      selectedRegionCodes?.map(code => {
        countryDataArr = countryDataArr.map(country => {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
              isDisabled: true
            });
          }

          return TravellingTo_objectSpread({}, country);
        });
      });
      setCountryData(countryDataArr);
    }

    setOtherCountry(!showOtherCountry);
  };

  const handleDescriptionModal = country => {
    const clickedTime = (0,utility_src/* getSessionStorageItem */.St)("clickedTime") ? (0,utility_src/* getSessionStorageItem */.St)("clickedTime") : {};
    const currentTime = new Date().getTime();
    const code = country.code;

    if (!clickedTime[country.code] || currentTime - parseInt(clickedTime[country.code], 10) >= 1800000) {
      clickedTime[code] = currentTime.toString();
      (0,utility_src/* setSessionStorageItem */.D9)("clickedTime", TravellingTo_objectSpread({}, clickedTime));
      return country.description;
    }

    return "";
  };

  const handlePopularCountrySelect = code => {
    setIsCountryError(false);
    let popularCountryArr = popularCountries?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return TravellingTo_objectSpread({}, country);
        }

        if (country.type === "REGION") {
          setDescriptionTxt(handleDescriptionModal(country));
          setDescTitle(country.descTitle);
        }

        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const isExclusiveCountrySelected = popularCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    popularCountryArr = popularCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return !country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      } else if (popularCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      }

      return TravellingTo_objectSpread({}, country);
    });
    const selectedPopRegionCodes = popularCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedPopRegionCodes.map(item => {
      popularCountryArr = popularCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return TravellingTo_objectSpread({}, country);
      });
    });
    const selectedCountries = popularCountryArr.filter(country => country.isSelected && !country.isDisabled);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "sco:popular_country_selected"
      }
    }, {
      countries: selectedCountries
    });
    setPopularCountries(popularCountryArr);
    setShowCountry(popularCountryArr);
    const countries = popularCountryArr.filter(data => data.isSelected && !data.isDisabled).map(data => data.code).join(",");

    if (countries) {
      (0,insurance_utils/* replaceHistory */.df)("countries", countries);
    } else {
      (0,insurance_utils/* replaceHistoryRemoveParams */._A)("countries");
    }
  };

  const handleSegementSelect = segmentId => {
    if (travelSearchForm?.segments?.value) {
      let updatedData = travelSearchForm?.segments?.value.map(item => {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          (0,insurance_utils/* replaceHistory */.df)("segment", item.id);
        } else {
          item.isSelected = false;
        }

        return item;
      });
      setSegments(updatedData);
    }
  };

  const handleSegmentClick = segmentId => {
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "sco:segment_clicked"
      }
    }, {
      journeyType: segmentId?.toString().toLowerCase() || ""
    });

    if (travelSearchForm?.segments?.value) {
      let updatedData = travelSearchForm?.segments?.value.map(item => {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          (0,insurance_utils/* replaceHistory */.df)("segment", item.id);
          TravellingTo_analytics?.trackLandingEvents({
            actionType: item.config.clickEventName
          } //"click"
          );
        } else {
          item.isSelected = false;
        }

        return item;
      });
      setSegments(updatedData);
    }
  };

  let toastTimeout = null;

  const toggleSegmentModal = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const countryCodes = countries?.split(",");

    if (!countryCodes) {
      setIsCountryError(true);
    } else if (countryCodes[0] == "IN" && segmentSelected?.id === "STUDENT") {
      setCountrySelectToastMsg("We do not have domestic student plans, please select another country to see student plans");
      if (toastTimeout) clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => {
        setCountrySelectToastMsg("");
      }, 2000);
    } else {
      segmentSelected?.modal && setIsSegmentModalShown(true);
    }
  };

  const onSubmit = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const isUpcomingTrip = searchParams.get("isUpcomingTrip");
    let countryCodes = countries?.split(","); // If no countries in URL, check the state for selected countries

    if (!countryCodes) {
      const selectedCountriesFromState = showCountry?.filter(country => country.isSelected && !country.isDisabled)?.map(country => country.code);

      if (selectedCountriesFromState?.length > 0) {
        countryCodes = selectedCountriesFromState; // Update URL with selected countries from state

        (0,insurance_utils/* replaceHistory */.df)("countries", selectedCountriesFromState.join(",")); // Clear any existing country error since we found selected countries

        setIsCountryError(false);
      }
    }

    if (!countryCodes || countryCodes.length === 0) {
      setIsCountryError(true);
      TravellingTo_analytics?.trackLandingEvents({
        actionType: "error_shown",
        payload: error_message
      } //"click"
      );
      (0,xdmEvents/* errorTrackEvent */.t1)({
        error_details_list: [{
          message: error_message,
          source: "country_select",
          severity: "P3"
        }]
      });
      return; // Don't proceed with API call if no countries are selected
    } else {
      // Clear error if we have countries
      setIsCountryError(false);
    }

    if (isUpcomingTrip) {
      (0,insurance_utils/* replaceHistoryRemoveParams */._A)("isUpcomingTrip");
      searchParams.delete("isUpcomingTrip");
      (0,utility_src/* removeSessionStorageItem */.lD)(src.STORAGE_KEYS.TRAVELLER_DETAILS);
    }

    (0,insurance_utils/* replaceHistory */.df)("segment", segmentSelected?.id);

    if (calenderValue && countValue && countryCodes?.length) {
      const selectedPopCountries = (popularCountries ?? []).filter(country => countryCodes?.includes(country.code)).map(item => item.name).join("|");
      TravellingTo_analytics?.trackLandingEvents({
        actionType: "popular_country_selected",
        payload: selectedPopCountries
      } //"click"
      );
      const queryParams = Object.fromEntries(searchParams.entries());

      const params = TravellingTo_objectSpread(TravellingTo_objectSpread({}, queryParams), {}, {
        startDate: (0,insurance_utils/* convertDateToUnix */.cJ)(calenderValue.from).toString(),
        endDate: calenderValue.to ? (0,insurance_utils/* convertDateToUnix */.cJ)(calenderValue.to).toString() : searchParams.get("endDate"),
        travellers: countValue,
        countries: countryCodes,
        segment: segmentSelected?.id
      });

      TravellingTo_analytics?.trackLandingEvents({
        actionType: "explore_plan_click"
      } //"click"
      );
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "explore_plan_click"
        }
      });
      const partner = (0,insurance_utils/* getPartnerOnClientSide */.et)();
      const requestData = {
        query: {
          source: "seo"
        },
        partner,
        userSearchIntent: {
          country: countryCodes,
          departureDateTime: (0,insurance_utils/* convertDateToUnix */.cJ)(calenderValue.from),
          arrivalDateTime: calenderValue.to ? (0,insurance_utils/* convertDateToUnix */.cJ)(calenderValue.to) : Number(searchParams.get("endDate")),
          numberOfTravellers: countValue,
          segment: segmentSelected?.id
        }
      };

      try {
        const response = await (0,api/* getNextPageRouteDetails */.$P)(requestData);
        const {
          responseStatus,
          nextPageRouteConfig
        } = response;

        if (responseStatus === src.RESPONSE_STATUS.SUCCESS) {
          navigation/* navigationActionsSeo.navigateToPageByRouteName */.Ro.navigateToPageByRouteName(`${nextPageRouteConfig?.route}`);
        }
      } catch (error) {
        console.error("NEXT PAGE ROUTE FAILURE ERROR ----", {
          error: error?.response
        });

        if (error?.response?.status === 401) {
          const domain = partner === src.PARTNER.GI ? ".goibibo.com" : ".makemytrip.com";

          if ((0,insurance_utils/* getCookieByName */.A7)("next_page_req")) {
            document.cookie = `next_page_req=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/`;
          }

          document.cookie = `next_page_req= ${JSON.stringify(requestData)}; expires=${new Date(Date.now() + 15 * 60 * 1000).toUTCString()}; domain=${domain}; path=/`;

          if (device === "sm" && partner === src.PARTNER.MMT) {
            const host = window.location.host;
            const req = {
              url: window.location.pathname + window.location.search
            };
            document.cookie = "loginActionDetails=" + JSON.stringify(`https://${host}/insurance/next-page`) + ";domain=.makemytrip.com;path=/";
            window.location.href = "https://www.makemytrip.com/pwa/hlp/v3/login";
          }

          setLoginModal?.("LOGIN");
        } else {
          setNextPageError(error?.response);
        }
      }
    }
  };

  const isExclusiveCountrySelected = countryData.find(item => item.isExclusiveSelection && item.isSelected);

  if (nextPageError && true) {
    throw new utility_src/* ClientError */.XF(nextPageError);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyleWrap */.fK, {
    "data-test-id": "TravellingTo-TravellingToStyleWrap",
    children: [travelSearchBanner ? /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* DiscountingNote */.S_, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-DiscountingNote",
      children: [travelSearchBanner?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        width: "24px",
        height: "24px",
        src: travelSearchBanner?.icon,
        style: {
          animation: "rotate 2s linear infinite"
        },
        loading: "eager"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        flexDirection: device === "sm" ? "column" : "row",
        margin: "0px 0px 0px 4px",
        gap: device === "lg" ? "4px" : "0px",
        "data-test-id": "TravellingTo-FlexComp",
        children: [travelSearchBanner?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travelSearchBanner?.title,
          baseStyle: {
            fontWeight: "bold",
            fontSize: device === "lg" ? "16px" : "12px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        }), travelSearchBanner?.description && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travelSearchBanner?.description,
          baseStyle: {
            fontWeight: "regular",
            fontSize: device === "lg" ? "14px" : "12px",
            marginTop: device === "lg" ? "2px" : "0px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_style/* TravelNote */.Me, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: travelNote,
        "data-test-id": "TravellingTo-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDetails_style/* TravellingToStyle */.s0, {
      "data-test-id": "TravellingTo-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "TravellingTo-H5Tag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: label,
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        margin: "0px 0px 20px 0px",
        "data-test-id": "TravellingTo-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: placeHolder,
          baseStyle: {
            color: "#717171"
          },
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_UpcomingTrips, {
        country: upcomingTrip?.country,
        countryCode: upcomingTrip?.countryCode,
        travelDuration: upcomingTrip?.travelDuration,
        travellerNum: upcomingTrip?.travellerNum,
        travellerTitle: upcomingTrip?.travellerTitle,
        handleUpcomingTripClick: handleUpcomingTripClick,
        "data-test-id": "TravellingTo-UpcomingTrips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        color: Global/* theme.greyText7 */.rS.greyText7,
        fontWeight: "bold",
        fontSize: "xs",
        margin: "2px 0 8px",
        "data-test-id": "TravellingTo-SpanTag",
        children: popularCountryTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: "Popular Destination",
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PopularCountryCompV2, {
        otherCountryTxt: otherCountryTxt,
        handleShowOtherCountry: handleShowOtherCountry,
        popCountry: showCountry,
        setIsSelectedError: setIsSelectedError,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        handlePopularCountrySelect: handlePopularCountrySelect,
        "data-test-id": "TravellingTo-PopularCountryComp"
      }), isCountryError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        color: Global/* theme.redText2 */.rS.redText2,
        fontSize: "xs",
        margin: device === "sm" ? "0 0 8px" : "8px 0 0",
        "data-test-id": "TravellingTo-ParaTag",
        children: error_message
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionDividers */.LV, {
        margin: "14px -30px 14px",
        backgroundColor: "#FFFFFF",
        xs: true,
        "data-test-id": "TravellingTo-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellingToWidget, {
        travelPurposeTxt: travelPurposeTxt,
        travCountTitle: travCountTitle,
        travPurpTitle: travPurpTitle,
        travDateTitle: travDateTitle,
        btnDisabledState: btnDisabledState,
        setCountValue: setCountValue,
        calendarDatesLimit: calendarDatesLimit,
        setCalenderValue: setCalenderValue,
        upcomingTravellerNum: upcomingTrip?.travellerNum,
        upcomingFromDate: upcomingTrip?.travelDuration?.startDate,
        upcomingToDate: upcomingTrip?.travelDuration?.endDate,
        calendarConfig: isExclusiveCountrySelected?.config?.calendar || segmentSelected?.config || calendarDatesLimit,
        "data-test-id": "TravellingTo-TravellingToWidget"
      }), travelSearchForm?.segments && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        margin: "0 0 24px",
        gap: "8px",
        flexDirection: "column",
        "data-test-id": "TravellingTo-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
          fontSize: "xs",
          fontWeight: "bold",
          textTransform: "uppercase",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "TravellingTo-ParaTag",
          children: travelSearchForm?.segments?.label
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Tags */.$G, {
          handleClickTab: handleSegmentClick,
          data: travelSearchForm?.segments?.value,
          "data-test-id": "TravellingTo-Tags"
        })]
      }), isSegmentModalShown && segmentSelected && segmentSelected?.modal && /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* CommonModalDweb */.Eq, {
        customIcon: segmentSelected?.modal?.icon,
        customTitle: segmentSelected?.modal?.title,
        handleClick: () => {
          setIsSegmentModalShown(false);
        },
        nonClipHeading: true,
        "data-test-id": "TravellingTo-CommonModalDweb",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
          fontSize: "md",
          color: Global/* theme.greyText */.rS.greyText,
          margin: "0 0 36px",
          "data-test-id": "TravellingTo-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
            value: segmentSelected?.modal?.description,
            "data-test-id": "TravellingTo-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
          justifyContent: "space-between",
          alignItems: "center",
          "data-test-id": "TravellingTo-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
            handleClick: () => {
              setIsSegmentModalShown(false);
            },
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "TravellingTo-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: segmentSelected?.modal?.secondaryCtaText,
              "data-test-id": "TravellingTo-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* AnchorTag */.Y6, {
            handleClick: () => {
              setIsSegmentModalShown(false);
              onSubmit();
            },
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "TravellingTo-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: segmentSelected?.modal?.primaryCtaText,
              "data-test-id": "TravellingTo-FormattedText"
            })
          })]
        })]
      }), travelBtnTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButton */.WB, {
        buttonref: buttonRef,
        customWidth: "100%",
        customTitle: travelBtnTxt,
        onClick: segmentSelected?.modal && travelSearchForm?.segments ? toggleSegmentModal : onSubmit,
        "data-test-id": "TravellingTo-LandingButton"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        color: Global/* theme.greyText */.rS.greyText,
        margin: "16px 0 0",
        "data-test-id": "TravellingTo-ParaTag",
        children: travelSearchForm?.disclaimer
      }), showOtherCountry && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_SelectCountryModal, {
        countryData: countryData,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        showCountry: showCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModal"
      }), showOtherCountry && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_SelectCountryModalSheet, {
        countryData: countryData,
        showCountry: showCountry,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModalSheet"
      }), descriptionTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionModal_DescriptionModal, {
        handleDescriptionModal: () => setDescriptionTxt(""),
        value: descriptionTxt,
        title: descTitle,
        "data-test-id": "TravellingTo-DescriptionModal"
      }), isSelectedError && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      }), isSelectedError && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "10px",
        "data-test-id": "TravellingTo-WebToast"
      }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WebToast */.Bu, {
        toastTxt: countrySelectToastMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      })]
    })]
  });
};

/* harmony default export */ const TravelDetails_TravellingTo = (TravellingTo);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravelDetails/TravellingToShimmer.tsx + 1 modules
var TravellingToShimmer = __webpack_require__(62915);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.style.ts
var TravellingToWidget_style = __webpack_require__(98892);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravelDateWiget.tsx








const TravelDateWiget = ({
  showTravDate,
  handleTravDate,
  ref,
  travDateTitle,
  startDate,
  endDate
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravelDateWigetStyle */.Jp, {
    ref: ref,
    onClick: handleTravDate,
    "data-test-id": "TravelDateWiget-TravelDateWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      gap: "8px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [travDateTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        textTransform: "uppercase",
        color: showTravDate ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravelDateWiget-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travDateTitle,
          "data-test-id": "TravelDateWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* ChevStateWrap */.N, {
        open: showTravDate,
        "data-test-id": "TravelDateWiget-ChevStateWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
          "data-test-id": "TravelDateWiget-BlueChev"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      gap: "4px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [startDate?.getDate(), " \xA0", startDate ? src.MONTHS[parseInt(startDate?.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", startDate?.getFullYear().toString().slice(-2)]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: startDate && src.LONG_WEEK_DAYS[startDate.getDay()]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* DateSeparator */.ZP, {
        "data-test-id": "TravelDateWiget-DateSeparator",
        children: "-to-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [endDate ? endDate.getDate() : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? 1 : startDate.getDate() + 1 : null, "\xA0", endDate ? src.MONTHS[parseInt(endDate.getMonth().toString().slice(-2))] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? src.MONTHS[parseInt((startDate.getMonth() + 1).toString().slice(-2))] : src.MONTHS[parseInt(startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SpanTag */.pF, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", endDate ? endDate.getFullYear().toString().slice(-2) : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? startDate.getMonth() === 11 ? (startDate.getFullYear() + 1).toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : null]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: endDate ? src.LONG_WEEK_DAYS[endDate.getDay()] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? src.LONG_WEEK_DAYS[new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1).getDay()] : src.LONG_WEEK_DAYS[startDate.getDay()] : null
        })]
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravelDateWiget = (TravelDateWiget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellerCounterWiget.tsx






const TravellerCounterWiget = ({
  showTravCount,
  handleCaptureCountIncr,
  handleCaptureCountDecr,
  captureCount,
  travCountTitle,
  travCountSubtitle
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCountWigetStyle */.Dq, {
    "data-test-id": "TravellerCounterWiget-TravellerCountWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA, {
      flexDirection: "column",
      "data-test-id": "TravellerCounterWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        textTransform: "uppercase",
        color: showTravCount ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travCountTitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        color: Global/* theme.greyText6 */.rS.greyText6,
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountSubtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: travCountSubtitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* CounterWrap */.vg, {
      "data-test-id": "TravellerCounterWiget-CounterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
        isDiabled: captureCount == 1,
        onClick: handleCaptureCountDecr,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6 11.0938H17.5V12.9064H6V11.0938Z",
            fill: "#008CFF"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: captureCount && captureCount <= 9 ? "0" + captureCount : captureCount
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
        isDiabled: captureCount == 20,
        onClick: handleCaptureCountIncr,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.612 6.04785V11.1719H17.496V12.7919H12.612V17.9519H10.86V12.7919H6V11.1719H10.86V6.04785H12.612Z",
            fill: "#008CFF"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellerCounterWiget = (TravellerCounterWiget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/TravellingToWidget/TravellingToWidget.tsx












const TravellingToWidget_analytics = (0,insurance/* getAnalytics */.I)();

const TravellingToWidget = ({
  travelPurposeTxt,
  travCountTitle,
  travPurpTitle,
  travDateTitle,
  btnDisabledState,
  setCountValue,
  calendarDatesLimit,
  setCalenderValue,
  calenderRef,
  upcomingTravellerNum,
  upcomingFromDate,
  upcomingToDate,
  calendarConfig
}) => {
  const {
    endDateErrorMessage,
    insPurchaseDateLimitInDays,
    //total no. of allowed days from start date (for end date)
    insPurchaseEndDateLimitInDays,
    //max no. of allowed days from start date (for end date)
    insPurchaseStartDateLimitInDays,
    //max no. of allowed days from current date (for start date)
    insPurchaseStartDateMinLimitInDays,
    //min no. of days from current date (for start date)
    startDateErrorMessage,
    insPurchaseEndDateMinLimitInDays
  } = (calendarConfig ? calendarConfig : calendarDatesLimit) || {};
  const from = (0,insurance_utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateMinLimitInDays);
  const to = (0,insurance_utils/* addDaysToDate */.Xz)(from || new Date(), insPurchaseEndDateMinLimitInDays || 0);
  const defaultSelected = {
    from,
    to
  };
  const maxEndDate = (0,insurance_utils/* addDaysToDate */.Xz)(new Date(), insPurchaseDateLimitInDays);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const ref = (0,react.useRef)(null);
  const divRefs = (0,react.useRef)([]);
  const {
    0: captureCount,
    1: setCaptureCount
  } = (0,react.useState)(1);
  const {
    0: dateTab,
    1: setDateTab
  } = (0,react.useState)(0);
  const {
    0: range,
    1: setRange
  } = (0,react.useState)(defaultSelected);
  const {
    0: showToast,
    1: setShowToast
  } = (0,react.useState)(false);
  const {
    0: toastMessage,
    1: setToastMessage
  } = (0,react.useState)("");
  const {
    0: startDate,
    1: setStartDate
  } = (0,react.useState)(new Date());
  const {
    0: endDate,
    1: setEndDate
  } = (0,react.useState)();
  const {
    0: focusedIndex,
    1: setFocusedIndex
  } = (0,react.useState)(-1);
  const prevFocusedIndexRef = (0,react.useRef)(focusedIndex);

  const handleClickOutside = event => {
    if (ref?.current && !ref?.current?.contains(event.target)) {
      setFocusedIndex(-1);
      setShowToast(false);
    }
  };

  const addTravellerNumber = travNumber => {
    if (travNumber > src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS || travNumber < src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS);
      (0,XDMAnalytics.updateSearchContext)({
        travellers: src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS
      });
      (0,insurance_utils/* replaceHistory */.df)("travellers", src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS.toString());
    } else {
      setCaptureCount(travNumber);
      (0,XDMAnalytics.updateSearchContext)({
        travellers: travNumber
      });
      (0,insurance_utils/* replaceHistory */.df)("travellers", travNumber.toString());
    }
  };

  const addTravellerDates = (travStartDate, travEndDate) => {
    const tempFromDate = (0,insurance_utils/* convertUnixToDate */.P9)(travStartDate);
    const tempToDate = (0,insurance_utils/* convertUnixToDate */.P9)(travEndDate);
    (0,insurance_utils/* replaceHistory */.df)("startDate", travStartDate.toString());
    (0,insurance_utils/* replaceHistory */.df)("endDate", travEndDate.toString());
    (0,XDMAnalytics.updateSearchContext)({
      fromDateTime: travStartDate,
      toDateTime: travEndDate
    });
    setRange({
      from: tempFromDate,
      to: tempToDate
    });
  };

  (0,react.useEffect)(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);
  (0,react.useEffect)(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const trav = queryParameters.get("travellers");
    const fromDate = queryParameters.get("startDate");
    const toDate = queryParameters.get("endDate");

    if (trav && !Number.isNaN(parseInt(trav))) {
      addTravellerNumber(parseInt(trav));
    } else if (upcomingTravellerNum) {
      addTravellerNumber(upcomingTravellerNum);
    }

    if (fromDate && toDate) {
      addTravellerDates(parseInt(fromDate), parseInt(toDate));
    } else if (upcomingFromDate && upcomingToDate) {
      addTravellerDates(upcomingFromDate, upcomingToDate);
    } else {
      (0,XDMAnalytics.updateSearchContext)({
        fromDateTime: defaultSelected.from?.getTime() ? defaultSelected.from.getTime() / 1000 : undefined,
        toDateTime: defaultSelected.to?.getTime() ? defaultSelected.to.getTime() / 1000 : undefined
      });
    }
  }, []);
  (0,react.useEffect)(() => {
    setEndDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
  }, []);
  (0,react.useEffect)(() => {
    if (captureCount >= src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCountValue(captureCount);
    }
  }, [captureCount]);
  (0,react.useEffect)(() => {
    if (range) {
      setCalenderValue(range);
    }
  }, [range]);
  (0,react.useEffect)(() => {
    const datePickerElement = document.getElementById("datePickerContainer");

    if (datePickerElement) {
      const rect = datePickerElement.getBoundingClientRect();
      const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (prevFocusedIndexRef.current === 0 && focusedIndex !== 0) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (focusedIndex === 0 && !isInView) {
        const offset = rect.top + rect.height / 2 - window.innerHeight / 2;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    }

    prevFocusedIndexRef.current = focusedIndex;
  }, [focusedIndex]);
  (0,react.useEffect)(() => {
    if (range?.to === undefined && range?.from) {
      let tempToDate = new Date(range?.from);
      tempToDate.setDate(tempToDate.getDate() + 1);
      (0,insurance_utils/* replaceHistory */.df)("endDate", (0,insurance_utils/* convertDateToUnix */.cJ)(tempToDate).toString());
    }
  }, [range?.from]);

  const handleClick = index => {
    if (index === focusedIndex) {
      setFocusedIndex(-1);
      setShowToast(false);
    } else {
      setFocusedIndex(index);
    }
  };

  const handleDayClick = selectedDate => {
    if (dateTab === 0) {
      const maxStartDate = (0,insurance_utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateLimitInDays);

      if (maxStartDate && maxStartDate < selectedDate) {
        // alert(startDateErrorMessage);
        setShowToast(true);
        setToastMessage(startDateErrorMessage);
      } else if (range?.from && range?.to) {
        setRange({
          from: selectedDate,
          to: undefined
        });
        (0,insurance_utils/* replaceHistory */.df)("startDate", (0,insurance_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
        setDateTab(1);
        setShowToast(false);
      }
    } else if (dateTab === 1) {
      if (range?.from) {
        const fromDate = new Date(range?.from);
        const maxEndDate = (0,insurance_utils/* addDaysToDate */.Xz)(fromDate, calendarConfig?.insPurchaseEndDateLimitInDays);

        if (range?.from > selectedDate) {
          setRange({
            from: selectedDate,
            to: undefined
          });
          setShowToast(false);
        } else if (maxEndDate && maxEndDate <= selectedDate) {
          setShowToast(true);
          setToastMessage(endDateErrorMessage);
        } else {
          setRange({
            from: range?.from,
            to: selectedDate
          });
          setShowToast(false);
          setDateTab(0);

          if (device == "lg") {
            setFocusedIndex(1);
          }

          (0,insurance_utils/* replaceHistory */.df)("endDate", (0,insurance_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
          TravellingToWidget_analytics?.trackLandingEvents({
            actionType: "travel_date_selected",
            payload: {
              departure: range.from?.toLocaleDateString("en-GB")?.replace(/\//gi, ":"),
              arrival: range.to?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || ""
            }
          } //"click"
          );
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: "travel_date_selected"
            }
          }, {
            fromDateTime: (0,insurance_utils/* convertDateToUnix */.cJ)(range?.from),
            toDateTime: (0,insurance_utils/* convertDateToUnix */.cJ)(selectedDate)
          });
        }
      }
    }
  };

  const handleCaptureCountIncr = () => {
    captureCount < src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS ? setCaptureCount(captureCount + 1) : setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS);
    (0,XDMAnalytics.updateSearchContext)({
      travellers: captureCount < src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS ? captureCount + 1 : src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS
    });
    (0,insurance_utils/* replaceHistory */.df)("travellers", (captureCount + 1).toString());
  };

  const handleCaptureCountDecr = () => {
    captureCount > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? setCaptureCount(captureCount - 1) : setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS); // if (device == 'lg') {
    //     setFocusedIndex(2);
    // }

    (0,XDMAnalytics.updateSearchContext)({
      travellers: captureCount > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? captureCount - 1 : src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS
    });
    (0,insurance_utils/* replaceHistory */.df)("travellers", (captureCount - 1).toString());
  };

  const handleSubmit = (chkIn, chkOut) => {
    chkIn && setStartDate(chkIn);
    chkOut && setEndDate(chkOut);
    TravellingToWidget_analytics?.trackLandingEvents({
      actionType: "travel_date_selected",
      payload: {
        departure: chkIn?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || "",
        arrival: chkOut?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || ""
      }
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "travel_date_selected"
      }
    }, {
      fromDateTime: chkIn ? (0,insurance_utils/* convertDateToUnix */.cJ)(chkIn) : 0,
      toDateTime: chkOut ? (0,insurance_utils/* convertDateToUnix */.cJ)(chkOut) : 0
    });
    setFocusedIndex(-1);
    setShowToast(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellingToWidgetStyle */.bF, {
    ref: device == "lg" ? ref : null,
    "data-test-id": "TravellingToWidget-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravelDateWiget, {
      ref: divRefs.current[0],
      showTravDate: focusedIndex == 0,
      handleTravDate: () => handleClick(0),
      travDateTitle: travDateTitle,
      startDate: range?.from,
      endDate: range?.to,
      "data-test-id": "TravellingToWidget-TravelDateWiget"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellerCounterWiget // ref={divRefs.current[1]}
    // showTravCount={focusedIndex == 1}
    , {
      captureCount: captureCount,
      travCountTitle: travCountTitle,
      handleCaptureCountIncr: handleCaptureCountIncr,
      handleCaptureCountDecr: handleCaptureCountDecr,
      "data-test-id": "TravellingToWidget-TravellerCounterWiget"
    }), focusedIndex == 0 && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* DatePickerComp */.X9, {
      startDateLabel: "Start Date",
      endDateLabel: "End Date",
      handleDayClick: handleDayClick,
      dateTab: dateTab,
      selected: range,
      from: range?.from,
      to: range?.to,
      maxEndDate: maxEndDate,
      toastMessage: toastMessage,
      showToast: showToast,
      "data-test-id": "TravellingToWidget-DatePickerComp"
    }), focusedIndex == 0 && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ReactPortalComp */.hK, {
      "data-test-id": "TravellingToWidget-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RangeDatePicker */.$m, {
        calendarFooter: true,
        calendarHeader: true,
        onBackPress: () => handleClick(0),
        onSubmitButtonPress: handleSubmit,
        range: true,
        calenderRef: calenderRef,
        from: range?.from,
        to: range?.to,
        toastMessage: toastMessage,
        showToast: showToast,
        selected: range,
        handleDayClick: handleDayClick,
        maxEndDate: maxEndDate,
        "data-test-id": "TravellingToWidget-RangeDatePicker"
      })
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellingToWidget = (TravellingToWidget);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhatsCovered/WhatsCovered.style.ts




const WhatsCoveredStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhatsCoveredstyle__WhatsCoveredStyle",
  componentId: "sc-1fouhoy-0"
})(["background:#fff;width:100%;", "{font-weight:900;}", " @media ", "{padding:0 16px;", "{> ", "{overflow-y:auto;-webkit-overflow-scrolling:touch;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;}}}"], components/* H2TagStyle */.FI, p => p.pageTheme === src.PARTNER.MMT && `
    ${components/* H4TagStyle */.sz}{
        font-size:24px;
        font-weight:900;
    }
    `, src.deviceType.mobile, ui_widgets_src/* InnerContentWrap */.IY, components/* FlexCompStyle */.lL);
const BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhatsCoveredstyle__BenefitItem",
  componentId: "sc-1fouhoy-1"
})(["flex:1;@media ", "{width:230px;flex-shrink:0;flex:none;}"], src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhatsCovered/WhatsCovered.tsx








const WhatsCovered = ({
  data,
  title,
  info
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const context = (0,hooks/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhatsCoveredStyle, {
    pageTheme: context ? context : undefined,
    "data-test-id": "WhatsCovered-WhatsCoveredStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "WhatsCovered-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
        "data-test-id": "WhatsCovered-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H5Tag */.jN, {
        "data-test-id": "WhatsCovered-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        fontSize: device == "lg" ? "large" : "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "0 0 66px",
        "data-test-id": "WhatsCovered-ParaTag",
        children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: info,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FlexComp */.bA, {
        gap: device == "lg" ? data?.length === 2 ? "50px" : "82px" : "24px",
        padding: "0 0 15px 0",
        "data-test-id": "WhatsCovered-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitItem, {
            "data-test-id": `WhatsCovered-BenefitItem-${index}`,
            children: [item.cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
              width: device == "lg" ? "164px" : "80px",
              height: device == "lg" ? "164px" : "80px",
              src: item.cardImg,
              "data-test-id": "WhatsCovered-ImageComponent"
            }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H4Tag */.j9, {
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-H4Tag",
              children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ParaTag */.dZ, {
              fontSize: "large",
              fontWeight: "black",
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-ParaTag",
              children: [" ", item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
              fontSize: device == "lg" ? "large" : "sm",
              color: device == "lg" ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
              "data-test-id": "WhatsCovered-ParaTag",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                value: item.info,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const WhatsCovered_WhatsCovered = (WhatsCovered);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhyBuyTravIns/WhyBuyTravIns.style.ts



const WhyBuyTravInsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyTravInsStyle",
  componentId: "dnzmib-0"
})(["background:#fff;width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}@media ", "{padding:0 16px;", "}"], p => p.pageTheme === src.PARTNER.GI && `
    background: #EFF3F8;
    padding-bottom:80px;
    `, components/* H2TagStyle */.FI, src.deviceType.mobile, src.deviceType.mobile, p => p.pageTheme === src.PARTNER.GI && `
    background: #fff;
    padding-top:16px;
    `);
const WhyFeatListWrap = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyFeatListWrap",
  componentId: "dnzmib-1"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:16px;flex-shrink:0;@media ", "{width:100%;grid-template-columns:repeat(1,1fr);}img{margin-top:4px;}"], src.deviceType.mobile);
const WhyBuyItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyItem",
  componentId: "dnzmib-2"
})(["display:flex;gap:8px;padding:16px;background:#ffffff;border:1px solid #ececec;box-shadow:0px 3px 12px rgba(0,0,0,0.2);border-radius:10px;width:300px;flex-shrink:0;font-size:18px;line-height:25px;svg{flex-shrink:0;}@media ", "{width:100%;box-shadow:none;}"], src.deviceType.mobile);
const ShieldWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhyBuyTravInsstyle__ShieldWrap",
  componentId: "dnzmib-3"
})(["position:absolute;right:-60px;z-index:-1;"]);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/WhyBuyTravIns/WhyBuyTravIns.tsx








const WhyBuyTravIns = ({
  title,
  info,
  data
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuyTravInsStyle, {
    "data-test-id": "WhyBuyTravIns-WhyBuyTravInsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui_widgets_src/* InnerContentWrap */.IY, {
      "data-test-id": "WhyBuyTravIns-InnerContentWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* FlexComp */.bA // flexWrap="wrap"
      , {
        flexDirection: device == "lg" ? "row" : "column",
        alignItems: "center",
        gap: device == "lg" ? "74px" : "24px",
        "data-test-id": "WhyBuyTravIns-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H2Tag */.yZ, {
            margin: "0 0 60px",
            "data-test-id": "WhyBuyTravIns-H2Tag",
            children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* H5Tag */.jN, {
            margin: "0 0 20px",
            "data-test-id": "WhyBuyTravIns-H5Tag",
            children: [" ", title && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
            fontSize: device == "lg" ? "large" : "sm",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "WhyBuyTravIns-ParaTag",
            children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
              value: info,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyFeatListWrap, {
          "data-test-id": "WhyBuyTravIns-WhyFeatListWrap",
          children: data && data.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(WhyBuyItem, {
              "data-test-id": `WhyBuyTravIns-WhyBuyItem-${index}`,
              children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
                src: item.icon,
                height: "24",
                width: "24",
                "data-test-id": "WhyBuyTravIns-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SpanTag */.pF, {
                "data-test-id": "WhyBuyTravIns-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
                  value: item?.info,
                  "data-test-id": "WhyBuyTravIns-FormattedText"
                })
              })]
            }, index);
          })
        }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(ShieldWrap, {
          "data-test-id": "WhyBuyTravIns-ShieldWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ImageComponent */.cu, {
            width: "286px",
            height: "320px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Light_Green_Shield_5cb1aff4ce.svg",
            "data-test-id": "WhyBuyTravIns-ImageComponent"
          })
        })]
      })
    })
  });
};

/* harmony default export */ const WhyBuyTravIns_WhyBuyTravIns = (WhyBuyTravIns);
;// CONCATENATED MODULE: ../../libs/insurance-landing-ui/src/lib/components/index.tsx






















/***/ })

}]);